var dutchTranslation = {
    translations: {
        philippinePassport: "Filipijns Paspoort",
        seamanBook: "Zeemansboek",
        philSysID: "PhilSys ID",
        iBP: "Integrated Bar of the Philippines (IBP)",
        driversLicense: "Rijbewijs",
        loading: "Laden...",
        loadingDataProvider: "Gegevensprovider laden...",
        tallySheetImport: {
            title: "Importen van processen-verbaal",
            subtitle: "Importeer ES&S- of CSV-bestanden van processen-verbaal, bekijk de gegenereerde stembussen vooraf en keur ze goed voordat ze processen-verbaal aanmaken.",
            createTitle: "Processen-verbaal importeren",
            detailTitle: "Import van proces-verbaal",
            empty: "Nog geen imports van processen-verbaal.",
            emptyBody: "Begin met het importeren van een ES&S Enhanced XML- of canoniek CSV-bestand voor deze verkiezingsgebeurtenis.",
            sourceFormat: {
                ESS_ENHANCED_XML: "ES&S Enhanced XML",
                CANONICAL_CSV: "Canonieke CSV",
            },
            channel: {
                PAPER: "Papier",
                POSTAL: "Post",
                IN_PERSON: "Persoonlijk",
            },
            table: {
                created: "Aangemaakt",
                createdBy: "Gemaakt door",
                file: "Bestand",
                format: "Formaat",
                channel: "Kanaal",
                status: "Status",
                labels: "Labels",
                annotations: "Annotaties",
                actions: "Acties",
            },
            summary: {
                imported: "Geïmporteerd",
                changed: "Gewijzigd",
                new: "Nieuw",
                unchanged: "Ongewijzigd",
                conflicted: "In conflict",
                errors: "Fouten",
            },
            status: {
                PENDING_REVIEW: "Wacht op beoordeling",
                APPROVED: "Goedgekeurd",
                DISAPPROVED: "Afgekeurd",
                FAILED_VALIDATION: "Validatie mislukt",
                CONFLICTED: "In conflict",
                NEW: "Nieuw",
                CHANGED: "Gewijzigd",
                UNCHANGED: "Ongewijzigd",
            },
            fields: {
                format: "Formaat",
                channel: "Kanaal",
                supportedFormats: "Ondersteunde formaten: XML, CSV",
                generatedTallySheet: "Gegenereerd proces-verbaal",
                sourceCandidates: "Bron-kandidaat-ID's",
                none: "Geen",
            },
            actions: {
                create: "Processen-verbaal importeren",
                review: "Beoordelen",
                source: "Bron",
                cancel: "Annuleren",
                preview: "Voorbeeld bekijken",
                save: "Import opslaan",
                approve: "Goedkeuren",
                disapprove: "Afkeuren",
                close: "Sluiten",
                openExisting: "Bestaande openen",
            },
            notifications: {
                selectFile: "Selecteer een importbestand voordat u het bekijkt",
                duplicateSource: "Deze hash van het bronbestand komt al voor in een eerdere import van proces-verbaal.",
                uploadUrlError: "Kon upload-URL niet aanmaken",
                uploadError: "Kon importbestand niet uploaden",
                previewEmpty: "Het voorbeeldantwoord was leeg",
                previewError: "Kon import niet bekijken",
                importEmpty: "Het importantwoord was leeg",
                created: "Import van proces-verbaal aangemaakt",
                createError: "Kon import niet aanmaken",
                reviewEmpty: "Het beoordelingsantwoord was leeg",
                conflicted: "Import heeft verouderde basislijnconflicten",
                approved: "Import goedgekeurd",
                disapproved: "Import afgekeurd",
                reviewError: "Kon import niet beoordelen",
                sourceUrlError: "Kon bron-downloadURL niet aanmaken",
                sourceDownloadError: "Kon bronbestand niet downloaden",
            },
            pagination: {
                range: "{{rangeStart}}-{{rangeEnd}} van {{total}}",
                previous: "Vorige",
                next: "Volgende",
            },
        },
        reconciliation: {
            menuButton: "Ext. kiezerssync",
            categories: {
                VOTED_INTERNET: "Gestemd via Internet",
                VOTED_OTHER_CHANNEL: "Gestemd via ander kanaal",
                DISABLED_DELETE_CALL: "Kiezer gedeactiveerd",
                DELETION_REVERTED: "Verwijdering teruggedraaid",
                PROFILE_UPDATE: "Profiel bijgewerkt",
                VOTER_ADDED: "Kiezer toegevoegd",
                REENABLED: "Kiezer heractiveerd",
                VOTED_UNMARKED: "Kiezer niet langer gemarkeerd als gestemd",
                ROW_FAILURE: "Rijfout",
            },
            table: {
                voterId: "Kiezer-ID",
                field: "Veld",
                category: "Categorie",
                currentValue: "Huidige waarde",
                newValue: "Nieuwe waarde",
                reason: "Reden",
                rowLabel: "Rij",
                noDifferences: "Geen verschillen gevonden - de systemen zijn gesynchroniseerd.",
            },
            wizard: {
                title: "Externe reconciliatiesynchronisatie",
                subtitle: "Synchroniseer de kiezerslijst met het externe systeem",
                drop: {
                    description: "Sleep het door het externe systeem gegenereerde reconciliatiebestand hierheen - beide diffs (externe zijde en Sequent-zijde) worden automatisch berekend en in aparte tabellen weergegeven.",
                    fileFormatLabel: "CSV-bestand",
                    uploading: "{{fileName}} wordt geüpload en beide diffs worden berekend...",
                },
                review: {
                    fileSummary: "{{fileName}} - Sequentie {{sequence}}, gegenereerd {{generatedAt}}",
                    rowFailuresWarning: "{{count}} rij(en) konden niet veilig worden gereconcilieerd en zijn uitgesloten van beide diffs - zie details hieronder.",
                    noDifferences: "Geen verschillen - beide systemen zijn al gesynchroniseerd.",
                    diffOnlyDifferences: "Dit is een convergentiecontrole voor een reeds toegepaste reeks. Verschillen worden ter opvolging getoond, maar deze ronde kan niet opnieuw worden toegepast.",
                    externalDiffTitle: "Externe diff",
                    sequentDiffTitle: "Sequent-diff",
                    downloadExternalPatch: "Externe patch downloaden",
                    externalDiffCaption: "Download de patch en lever deze buiten deze tool aan het externe systeem. Zodra het de patch toepast en het volgende reconciliatiebestand produceert, klik op 'Terug' en sleep dat bestand hierheen - 'Toepassen' wordt geactiveerd zodra deze tabel leeg is.",
                    noExternalDifferences: "Geen verschillen aan de externe zijde.",
                    sequentDiffCaption: "Pas wijzigingen direct toe op Sequent door op 'Toepassen' te klikken - hiervoor wordt geen patchbestand gegenereerd.",
                    noSequentDifferences: "Geen verschillen aan de Sequent-zijde.",
                },
                applying: {
                    inProgress: "Wijzigingen aan de Sequent-zijde worden toegepast...",
                    rowFailures: "{{count}} rij(en) zijn uitgesloten van deze ronde en vereisen handmatige opvolging - zie details hieronder.",
                    rowFailuresTruncated: "De eerste {{shown}} van {{count}} rijfouten worden getoond. Los de gemeenschappelijke oorzaak op en probeer opnieuw om de resterende fouten te zien.",
                    success: "Alle wijzigingen aan de Sequent-zijde zijn succesvol toegepast.",
                },
                actions: {
                    cancel: "Annuleren",
                    back: "Terug",
                    apply: "Toepassen",
                    next: "Volgende",
                    startOver: "Opnieuw beginnen",
                    close: "Sluiten",
                },
                confirm: {
                    title: "Reconciliatiewijzigingen bevestigen",
                    categoriesNote: "Categorieën die oranje zijn omlijnd ({{categories}}) hebben invloed op de stemstatus of deactiveren kiezers.",
                    applyChanges: "Wijzigingen toepassen",
                    continue: "Doorgaan",
                },
                summary: {
                    votedOtherChannel: "markeert {{count}} kiezer(s) als gestemd via een ander kanaal",
                    disabled: "deactiveert {{count}} kiezer(s)",
                    reenabled: "heractiveert {{count}} kiezer(s)",
                    votedUnmarked: "verwijdert de stemmarkering van {{count}} kiezer(s)",
                    profileUpdated: "werkt {{count}} profiel(en) bij",
                    voterAdded: "voegt {{count}} kiezer(s) toe",
                    prefix: "Dit past wijzigingen toe die {{parts}}.",
                    empty: "Er zijn geen wijzigingen aan de Sequent-zijde om toe te passen.",
                },
                notifications: {
                    envelopeLoadError: "Kon de reconciliatie-diff niet laden - probeer het opnieuw.",
                    generateFailed: "Kon de reconciliatie-diff niet berekenen - zie de taakwidget voor details.",
                    applyFailed: "Kon de wijzigingen aan de Sequent-zijde niet toepassen - zie de taakwidget voor details.",
                    uploadUrlError: "Kon geen upload-URL verkrijgen",
                    generateTaskError: "Kon de reconciliatie-difftaak niet starten",
                    uploadError: "Kon het reconciliatiebestand niet uploaden",
                    applyTaskError: "Kon de toepassingstaak niet starten",
                    applyError: "Kon de reconciliatiewijzigingen niet toepassen",
                },
            },
        },
        logsScreen: {
            noPermissions: "U hebt geen toestemming om toegang te krijgen tot de logs.",
            title: "Logs",
            subtitle: "Algemene logs van de hoofd- en IAM-databases",
            actions: {
                csv: "Exporteren als CSV",
                pdf: "Exporteren als PDF",
            },
            exportdialog: {
                description: "Bevestig dat u deze actie wilt uitvoeren. Dit kan even duren.",
            },
            column: {
                id: "Id",
                statement_kind: "Soort verklaring",
                created: "Aangemaakt",
                statement_timestamp: "Tijdstempel verklaring",
                message: "Bericht",
                user_id: "Gebruikers-ID",
                username: "Gebruikersnaam",
                sender_pk: "Afzender PK",
                log_type: "Logtype",
                event_type: "Eventtype",
                description: "Beschrijving",
                version: "Versie",
            },
            main: {
                title: "Logs Hoofddatabase",
            },
            iam: {
                title: "Logs IAM-database",
            },
        },
        tasksScreen: {
            noPermissions: "U hebt geen toestemming om toegang te krijgen tot logs.",
            title: "Uitvoering van Taken",
            subtitle: "Informatie over de uitgevoerde taken",
            taskInformation: "Taakinformatie",
            status: "Status: {{status}}",
            ok: "Ok",
            column: {
                id: "Index",
                name: "Taaknaam",
                type: "Type",
                execution_status: "Status",
                start_at: "Starttijd",
                end_at: "Eindtijd",
                executed_by_user: "Uitgevoerd door",
                annotations: "Annotaties",
                labels: "Labels",
                logs: "Logs",
            },
            tasksExecution: {
                DELETE_TENANT: "Tenant verwijderen",
                PUBLISH_BALLOT: "Stembiljet publiceren",
                VOTER_INFORMATION_LETTER: "Kiezersinformatiebrief",
                EXPORT_ELECTION_EVENT: "Verkiezingsevenement Exporteren",
                CREATE_ELECTION_EVENT: "Verkiezingsevenement Aanmaken",
                IMPORT_ELECTION_EVENT: "Verkiezingsevenement Importeren",
                IMPORT_USERS: "Gebruikers Importeren",
                EDIT_USER: "Kiezer Bewerken",
                IMPORT_CANDIDATES: "Kandidaten Importeren",
                EXPORT_VOTERS: "Kiezers Exporteren",
                CREATE_TRANSMISSION_PACKAGE: "Transmissiepakket Aanmaken",
                EXPORT_BALLOT_PUBLICATION: "Publicatie Stembiljet Exporteren",
                EXPORT_ACTIVITY_LOGS_REPORT: "Activiteitenlogboek Rapport Exporteren",
                GENERATE_REPORT: "Rapport Genereren",
                GENERATE_TRANSMISSION_REPORT: "Transmissierapport Genereren",
                EXPORT_TRUSTEES: "Trustees Exporteren",
                EXPORT_APPLICATION: "Applicaties Exporteren",
                EXPORT_TENANT_CONFIG: "Tenantconfiguratie Exporteren",
                IMPORT_TENANT_CONFIG: "Tenantconfiguratie Importeren",
                RENDER_DOCUMENT_PDF: "Document als PDF renderen",
                CREATE_TENANT: "Tenant Aanmaken",
                EXPORT_TEMPLATES: "Sjablonen Exporteren",
                IMPORT_TEMPLATES: "Sjablonen Importeren",
                DELETE_ELECTION_EVENT: "Verkiezingsevenement Verwijderen",
                DELETE_VOTERS: "Kiezers verwijderen",
                PREPARE_PUBLICATION_PREVIEW: "De publicatievoorbeeldweergave voorbereiden",
                EXPORT_TALLY_RESULTS_XLSX: "Exporteer de telresultaten in XLSX-indeling",
                EXPORT_CERTIFICATE_AUTHORITIES: "Certificaatautoriteiten exporteren",
                PUBLISH_RESULTS_WEBSITE: "Resultatenwebsite publiceren",
            },
            documentAccess: {
                title: "Documenttoegang",
                sensitivityNotice: "Gevoelige informatie. Deel dit wachtwoord alleen met de beoogde ontvanger.",
                passwordLabel: "Wachtwoord om de versleutelde PDF te openen",
                showPassword: "Wachtwoord tonen",
                copyPassword: "Wachtwoord kopiëren",
                passwordCopied: "Wachtwoord gekopieerd",
                passwordError: "Het PDF-wachtwoord kon niet worden opgehaald",
                copyError: "Het wachtwoord kon niet worden gekopieerd",
                guidance: "Het wachtwoord wordt pas geladen nadat u Wachtwoord tonen kiest. Daarna verschijnt hier een alleen-lezen veld met een kopieeroptie.",
            },
            widget: {
                taskTitle: "Taak: {{title}}",
                viewTask: "Taak Bekijken",
                downloadDocument: "Bestand Downloaden",
            },
            exportTasksExecution: {
                success: "Export succesvol voltooid",
                error: "Fout bij exporteren van taakuitvoering",
            },
        },
        areas: {
            common: {
                title: "Gebieden",
                subTitle: "Configuratie van gebieden.",
                deleteError: "Fout bij verwijderen van gebied",
            },
            createAreaSuccess: "Gebied aangemaakt",
            updateAreaSuccess: "Gebied bijgewerkt",
            createAreaError: "Kon gebied niet aanmaken",
            sequent_backend_area_contest: "Stemmingen",
            empty: {
                header: "Nog geen gebieden.",
                action: "Gebied aanmaken",
            },
            formImputs: {
                allowEarlyVoting: "Vroeg Stemmen Toestaan",
            },
        },
        integrationsScreen: {
            common: {
                gapiKey: "Google Calendar Service Account Sleutel",
                gapiEmail: "Google Calendar Authenticatie E-mail",
            },
            errors: {
                invalidGapiKey: "Ongeldig formaat voor Google Calendar Service Account Sleutel",
            },
        },
        lookAndFeelScreen: {
            common: {
                helpLinks: "Helplinks",
                logoUrl: "Logo-URL",
                css: "Aangepaste CSS",
            },
            errors: {
                invalidHelpLinks: "Ongeldig formaat voor Help Links",
            },
        },
        electionTypeScreen: {
            noPermissions: "U hebt geen toestemming om toegang te krijgen tot instellingen.",
            common: {
                title: "Verkiezingstype",
                subtitle: "Configuratie verkiezingstype",
                onlineVoting: "Online Stemmen",
                kioskVoting: "Kiosk Stemmen",
                telephoneVoting: "Telefonisch Stemmen",
                settingTitle: "Instellingen",
                settingSubtitle: "Algemene Configuratie",
                sms: "SMS",
                mail: "E-mails",
                createNew: "Verkiezingstype aanmaken",
                emptyHeader: "Nog geen verkiezingstypes.",
                emptyBody: "Wilt u er een aanmaken?",
            },
            create: {
                title: "Verkiezingstype aanmaken",
            },
            edit: {
                title: "Verkiezingstype bewerken",
            },
            tabs: {
                votingChannels: "STEMKANALEN",
                electionTypes: "VERKIEZINGSTYPES",
                templates: "SJABLONEN",
                languages: "TALEN",
                localization: "LOCALISATIE",
                integrations: "INTEGRATIES",
                lookAndFeel: "LOOK & FEEL",
                schedules: "GEPLANDE GEBEURTENISSEN",
                trustees: "TRUSTEES",
                BackupRestore: "BACK-UP / HERSTELLEN",
            },
        },
        trusteesSettingsScreen: {
            common: {
                emptyHeader: "Nog geen trustees.",
                createNew: "Trustee aanmaken",
                title: "Trustee",
                subtitle: "Configuratie trustee",
                emptyBody: "Wilt u er een aanmaken?",
            },
            create: {
                title: "Trustee aanmaken",
            },
            edit: {
                title: "Trustee bewerken",
            },
        },
        scheduleScreen: {
            noPermissions: "U hebt geen toestemming om toegang te krijgen tot instellingen.",
            createScheduleSuccess: "Schema aangemaakt",
            createScheduleError: "Fout bij aanmaken van schema",
            deleteScheduleSuccess: "Schema verwijderd",
            deleteScheduleError: "Fout bij verwijderen van schema",
            common: {
                title: "Schema's",
                subtitle: "Configuratie schema's",
                createNew: "Schema aanmaken",
                emptyHeader: "Nog geen schema's.",
                emptyBody: "Wilt u er een aanmaken?",
            },
            create: {
                title: "Schema aanmaken",
                selectSchedule: "Selecteer een schema uit de vooraf gedefinieerde lijst of maak een aangepast schema aan",
            },
            edit: {
                title: "Schema bewerken",
            },
            eventTypes: {
                SYSTEM_LOCKDOWN_FOR_INTERNET_VOTING_SETTINGS: "Systeemvergrendeling voor finalisatie van instellingen voor online stemmen",
                START_PRE_REGISTRATION_OVCS: "Start en einde van pre-registratie voor OVCS",
                END_PRE_REGISTRATION_OVCS: "Einde pre-registratie voor OVCS",
                START_TEST_VOTING_PERIOD: "Start teststemperiode",
                END_TEST_VOTING_PERIOD: "Einde teststemperiode",
                START_INTERNET_VOTING_PERIOD: "Start online stemperiode",
                END_INTERNET_VOTING_PERIOD: "Einde online stemperiode",
                LAB_TEST: "Labotest",
                FIELD_TEST: "Veldtest",
                MOCK_ELECTIONS: "Proefverkiezingen",
                FTS: "FTS",
            },
        },
        dashboard: {
            voteByDay: "Stemmen per dag",
            votesOverTime: "Stemmen in de tijd",
            timeResolution: "Tijdsresolutie",
            timeRange: "Tijdsbereik",
            minute: "Minuut",
            hour: "Uur",
            day: "Dag",
            votersByChannels: "Kiezers per kanaal",
            voterLoginURL: "Login URL kiezer",
            voterEnrollURL: "Inschrijvings-URL kiezer",
            voterEnrollKioskURL: "Inschrijvings-URL kiosk kiezer",
            ipAddress: {
                emptyState: "Nog geen stemmen.",
                title: "IP-adressen",
                ip: "IP",
                country: "Land",
                VoteCount: "Aantal stemmen",
                ElectionName: "Naam verkiezing",
                VotersId: "Kiezer Id",
            },
        },
        electionEventScreen: {
            common: {
                subtitle: "Configuratie verkiezingsevenement.",
                showMore: "Toon meer",
                showLess: "Toon minder",
                adminPortal: "Beheerdersportaal",
                allowPublishAfterLockdown: "Publicatie verkiezingsevenement enkel toestaan na vergrendeling",
                reset: "Aangepaste filter resetten",
            },
            edit: {
                general: "Algemeen",
                dates: "Datums",
                customUrls: "Aangepaste URL-prefix",
                votingPeriod: "Stemperiode",
                language: "Taal",
                languageAndRegion: "Taal en regio",
                allowed: "Toegestane stemkanalen",
                materials: "Ondersteunend materiaal",
                ballotDesign: "Ontwerp stembiljet",
                templates: "Sjablonen",
                reorder: "Volgorde verkiezingen wijzigen",
                advancedConfigurations: "Geavanceerde configuraties",
                importCandidates: "Kandidaten importeren",
                custom_filters: "Aangepaste filters",
                voter_authentication: "Kiezersauthenticatie",
                realm_attributes: "Keycloak realm-attributen",
                realm_attributes_load_error: "Fout bij het laden van Keycloak realm-attributen",
                realm_attributes_update_error: "Fout bij het bijwerken van Keycloak realm-attributen",
                realm_attributes_not_loaded: "Keycloak realm-attributen zijn niet geladen; wijzigingen zijn niet opgeslagen",
                password_policy: "Wachtwoordbeleid",
                password_policy_load_error: "Fout bij het laden van het Keycloak-wachtwoordbeleid",
                password_policy_update_error: "Fout bij het bijwerken van het Keycloak-wachtwoordbeleid",
                password_policy_not_loaded: "Het Keycloak-wachtwoordbeleid is niet geladen; wijzigingen zijn niet opgeslagen",
            },
            customUrls: {
                login: "Inloggen",
                enrollment: "Inschrijving",
            },
            localization: {
                emptyHeader: "Er zijn geen talen ingesteld voor het evenement",
                selectLanguage: "Selecteer Taal",
                notify: {
                    success: "Localisatie succesvol bijgewerkt",
                    error: "Bijwerken lokalisatie mislukt",
                    duplicateKey: "Er bestaat al een overschrijving met deze sleutel en dit bereik.",
                    invalidDateTimeFormat: "Ongeldige datum-/tijdnotatie. Gebruik de tokens yyyy, MM, dd, HH, mm, ss (bijv. dd/MM/yyyy HH:mm).",
                },
                common: {
                    title: "Localisatie",
                    subTitle: "Configuratie lokalisatie",
                },
                labels: {
                    key: "Sleutel",
                    scope: "Portalbereik",
                    value: "Waarde",
                },
                scopes: {
                    legacy: "Verouderd ({{portal}})",
                    global: "Globaal",
                    votingPortal: "Stemportaal",
                    ballotVerifier: "Stembiljetverificatie",
                    resultsPortal: "Resultatenportaal",
                    adminPortal: "Beheerportaal",
                },
            },
            field: {
                passwordPolicy: {
                    minimumLength: "Minimale lengte",
                    maximumLength: "Maximale lengte",
                    includeUppercase: "Hoofdletters opnemen",
                    includeLowercase: "Kleine letters opnemen",
                    includeDigits: "Cijfers opnemen",
                    includeSpecialCharacters: "Speciale tekens opnemen",
                    help: {
                        minimumLength: "Het minimale aantal tekens dat voor het wachtwoord vereist is.",
                        maximumLength: "Het maximale aantal tekens dat voor het wachtwoord is toegestaan.",
                        includeUppercase: "Het wachtwoord moet ten minste één hoofdletter bevatten.",
                        includeLowercase: "Het wachtwoord moet ten minste één kleine letter bevatten.",
                        includeDigits: "Het wachtwoord moet ten minste één cijfer bevatten.",
                        includeSpecialCharacters: "Het wachtwoord moet ten minste één speciaal teken bevatten.",
                    },
                    notConfigured: "Er is geen wachtwoordbeleid geconfigureerd. Bij het opslaan worden de onderstaande standaardwaarden toegepast.",
                    errors: {
                        lengthRange: "De waarden voor de wachtwoordlengte moeten gehele getallen tussen 1 en 256 zijn.",
                        minimumExceedsMaximum: "De minimale lengte mag niet groter zijn dan de maximale lengte.",
                        characterClassRequired: "Selecteer ten minste één tekenklasse voor het wachtwoord.",
                    },
                },
                name: "Naam",
                alias: "Alias",
                description: "Beschrijving",
                startDateTime: "Startdatum en -tijd",
                endDateTime: "Einddatum en -tijd",
                language: "Taal",
                votingChannels: "Stemkanalen",
                materialActivated: "Ondersteunend materiaal geactiveerd",
                supportMaterialsPolicy: {
                    label: "Beleid voor Ondersteunend Materiaal",
                    helperText: "Verplicht voor Stemmen vereist dat kiezers elk Ondersteunend Materiaal openen en bevestigen dat ze het hebben gelezen voordat ze kunnen stemmen.",
                    options: {
                        off: "Uit",
                        optional: "Optioneel",
                        mandatory_for_voting: "Verplicht voor Stemmen",
                    },
                },
                materialTitle: "Titel",
                materialSubTitle: "Ondertitel",
                logoUrl: "Logo-URL",
                userVerification: "U kunt een aangepast sjabloon invoeren dat zal worden gebruikt om kiezers handmatig te verifiëren",
                redirectFinishUrl: "Doorschakel-URL na voltooiing",
                kioskRedirectFinishUrl: "Doorstuur-URL na afronding van kioskstemmen",
                css: "Aangepaste CSS",
                skipElectionList: "Scherm verkiezingslijst overslaan",
                showUserProfile: "Gebruikersprofiel tonen",
                showCastVoteLogs: {
                    policyLabel: "Logboeken stemmen tonen",
                    options: {
                        "show-logs-tab": "Tab log stemmen tonen",
                        "hide-logs-tab": "Tab log stemmen verbergen",
                    },
                },
                lockdownState: {
                    policyLabel: "Vergrendelingsstatus",
                    options: {
                        "locked-down": "Vergrendeld",
                        "not-locked-down": "Niet vergrendeld",
                    },
                },
                decodedBallots: {
                    policyLabel: "Gedecodeerde stembiljetten opnemen in de resultaten database",
                    options: { "included": "Opnemen", "not-included": "Niet opnemen" },
                },
                contestEncryptionPolicy: {
                    options: {
                        "single-contest": "Enkele Stemming",
                        "multiple-contests": "Meerdere Stemmingen",
                    },
                    policyLabel: "Encryptiebeleid stemmingen",
                },
                votingPortalDateTimeFormat: {
                    policyLabel: "Datum- en tijdnotatie van stemportaal",
                    helperText: 'Geldt voor het hele evenement. Om per taal te overschrijven, voeg de sleutel "votingPortalDateTimeFormat" toe op het tabblad Localisatie met de tokens yyyy, MM, dd, HH, mm, ss (bijv. dd/MM/yyyy HH:mm). Zie de documentatie voor details.',
                    options: {
                        "legacy-gb-24h": "Legacy GB 24h (dd/MM/yyyy HH:mm, 24u)",
                        "iso-local": "ISO lokaal (yyyy-MM-dd HH:mm)",
                        "us-12h": "VS 12 u (MM/dd/yyyy h:mm AM/PM)",
                        "locale-medium": "Locale Medium (middellange datum, korte tijd)",
                        "date-only": "Date Only (geen tijd)",
                        "custom": "Aangepast formaat",
                    },
                    customFormat: {
                        label: "Aangepast datum- en tijdformaat",
                        helperText: "Gebruik de tokens yyyy, MM, dd, HH, mm, ss (bijv. dd/MM/yyyy HH:mm). Andere tekens worden letterlijk weergegeven.",
                        invalid: "Ongeldig formaat. Gebruik ten minste een van de tokens yyyy, MM, dd, HH, mm, ss.",
                    },
                },
                countDownPolicyOptions: {
                    NO_COUNTDOWN: "Geen aftelling",
                    COUNTDOWN: "Aftellen",
                    COUNTDOWN_WITH_ALERT: "Aftellen met waarschuwing",
                    sectionTitle: "Stemmingsportaal",
                    policyLabel: "Aftelbeleid stemmingsportaal",
                    coundownSecondsLabel: "tijd in seconden voor vervaldatum om af te tellen",
                    alertSecondsLabel: "tijd in seconden voor vervaldatum om uitlogwaarschuwing te tonen",
                },
                voterSigningPolicy: {
                    "policyLabel": "Ondertekeningsbeleid kiezer",
                    "no-signature": "Geen handtekening",
                    "with-signature": "Met handtekening",
                },
                VoterCertificatePolicy: {
                    policyLabel: "Beleid voor digitaal kiezerscertificaat",
                    enabled: "Ingeschakeld",
                    disabled: "Uitgeschakeld",
                },
                enrollment: {
                    policyLabel: "Inschrijving",
                    options: {
                        enabled: "Ingeschakeld",
                        disabled: "Uitgeschakeld",
                    },
                },
                otp: {
                    policyLabel: "OTP",
                    options: {
                        enabled: "Ingeschakeld",
                        disabled: "Uitgeschakeld",
                    },
                },
                ceremoniesPolicy: {
                    policyLabel: "Sleutel-/Telceremoniebeleid",
                    options: {
                        "automated-ceremonies": "Automatische ceremonies toestaan",
                        "manual-ceremonies": "Handmatige ceremonies",
                    },
                },
                automaticRecountPolicy: {
                    policyLabel: "Automatische hertelling na importgoedkeuring",
                    options: {
                        enabled: "Ingeschakeld",
                        disabled: "Uitgeschakeld",
                    },
                },
                weightedVotingPolicy: {
                    policyLabel: "Beleid voor Gewogen Stemmen",
                    options: {
                        "areas-weighted-voting": "Gewogen Stemmen per Gebied",
                        "voters-weighted-voting": "Gewogen Stemmen per Kiezer",
                        "disabled-weighted-voting": "Gewogen Stemmen Uitgeschakeld",
                    },
                    noDelegated: "Gewogen Stemmen per Kiezer kan niet worden gecombineerd met Gedelegeerd Stemmen",
                    noDecodedBallots: "Gewogen Stemmen per Kiezer kan niet worden gecombineerd met het opnemen van ontsleutelde stembiljetten in de resultaten",
                },
                delegatedVotingPolicy: {
                    policyLabel: "Gedelegeerd stembeleid",
                    options: {
                        enabled: "Ingeschakeld",
                        disabled: "Uitgeschakeld",
                    },
                },
                languageDetectionPolicy: {
                    policyLabel: "Taaldetectiebeleid",
                    options: {
                        "browser-detect": "Detecteren via browser",
                        "force-default": "Standaard afdwingen",
                    },
                },
                numberFormatPolicy: {
                    policyLabel: "Getalnotatiebeleid",
                    helperText: "Geldt voor de getallen in resultaten, dashboards en rapporten.",
                    unknownPolicy: "Onbekende notatie '{{policy}}', weergegeven als {{sample}}",
                },
            },
            error: {
                endDate: "Einddatum moet na startdatum liggen",
                startDate: "Startdatum moet in de toekomst liggen",
                noResult: "Nog geen verkiezingsevenement",
                endDateInvalid: "Einddatum moet in de toekomst liggen",
            },
            voters: {
                title: "Kiezers",
            },
            createElectionEventSuccess: "Verkiezingsevenement aangemaakt",
            createElectionEventError: "Fout bij aanmaken verkiezingsevenement",
            ivr: {
                tabs: {
                    config: "Configuratie",
                    blacklist: "Blokkeerlijst",
                    prompts: "Spraakprompts",
                    emulator: "Emulator",
                },
                common: {
                    saveSuccess: "Succesvol opgeslagen",
                    saveError: "Opslaan mislukt",
                    deleteSuccess: "Succesvol verwijderd",
                    deleteError: "Verwijderen mislukt",
                },
                config: {
                    configuredPhone: "Geconfigureerd telefoonnummer",
                    infoMsg: "Configureer hieronder de IVR-flow en de bijbehorende eigenschappen. Neem voor meer informatie contact op met Sequent.",
                },
                prompts: {
                    emptyMsg: "Nog geen prompts aangemaakt",
                    infoMsg: "Configureer de prompts die door de IVR worden gebruikt. Aankondigingsprompts zijn verplicht, en systeemprompts kunnen voor de gewenste talen worden overschreven. SSML wordt ondersteund, ook voor het mengen van talen.",
                    editorTitle: "Prompt",
                    editorSubtitle: "Promptconfiguratie",
                },
                blacklist: {
                    columns: {
                        phone: "Telefoonnummer",
                        reason: "Reden",
                        createdAt: "Aangemaakt op",
                        createdBy: "Aangemaakt door",
                        createdBefore: "Aangemaakt vóór",
                        createdAfter: "Aangemaakt na",
                    },
                    emptyMsg: "Er zijn geen vermeldingen in de blokkeerlijst",
                    infoMsg: "Configureer de blokkeerlijst voor de IVR. Oproepen van deze nummers worden automatisch door het systeem verbroken.",
                    noFilterMatch: "Geen vermeldingen komen overeen met de opgegeven filters",
                    phoneRequired: "Telefoonnummer is verplicht",
                },
                emulator: {
                    infoMsg: "Selecteer een gebied en de gewenste verkiezingen om de IVR-sessie te doorlopen.",
                    apiStatus: {
                        unavailable: "Het emulatorsysteem is niet beschikbaar in uw omgeving",
                        loading: "Het emulatorsysteem wordt geladen",
                        error: "Fout bij het laden van het emulatorsysteem",
                    },
                    hints: {
                        title: "Tips",
                        publishRequired: "Wijzigingen aan verkiezingen, stemmingen of kandidaten moeten eerst worden gepubliceerd voordat ze beschikbaar zijn. Alleen de meest recent gepubliceerde stembiljetstijlen voor het overeenkomstige gebied worden in de emulator gebruikt.",
                        eventChangesImmediate: "Wijzigingen aan het verkiezingsevenement, zoals de IVR-configuratie of aangepaste prompts, zijn direct beschikbaar nadat de emulatorsessie opnieuw is gestart.",
                        credentials: 'De geldige kiezer-ID en pincode zijn "123" en "123".',
                    },
                    sendDtmf: "DTMF-invoer verzenden",
                    sendTimeout: "Time-out verzenden",
                    disconnected: "Verbinding verbroken",
                    startSession: "Nieuwe sessie starten",
                    endSession: "Sessie beëindigen",
                    noStylesFound: "Geen gepubliceerde stembiljetstijlen gevonden die overeenkomen met uw selecties",
                    inputPlaceholder: "Voer uw invoer in (maximaal aantal cijfers={{maxDigits}}, geldige invoer={{validInputs}}, time-out={{timeout}} sec.)",
                    blacklistCaller: "Beller blokkeren",
                    elections: "Verkiezingen",
                    area: "Gebied",
                },
            },
            stats: {
                elegibleVoters: "Stemgerechtigde Kiezers",
                voters: "Effectieve Kiezers",
                elections: "Verkiezingen",
                contests: "Stemmingen",
                areas: "Gebieden",
                sentEmails: "Verzonden e-mails",
                sentSMS: "Verzonden SMS'en",
                calendar: {
                    title: "Kalender",
                    scheduled: "Gepland",
                },
            },
            keys: {
                createNew: "Sleutelceremonie aanmaken",
                emptyHeader: "Nog geen sleutelceremonie.",
                statusLabel: "Status",
                waitingKeys: "Wachten op sleutelgeneratie...",
                started: "Gestart op",
                actions: {
                    participate: "Deelnemen aan sleutelceremonie",
                    view: "Sleutelceremonie bekijken",
                },
                breadCrumbs: {
                    configure: "Configureren",
                    ceremony: "Ceremonie",
                    created: "Voltooid",
                    start: "Starten",
                    status: "Status",
                    download: "Downloaden",
                    check: "Controleren",
                    success: "Voltooid",
                },
                notify: {
                    participateNow: "U bent uitgenodigd om deel te nemen aan een sleutelceremonie. Gelieve op de Sleutelactie van de ceremonie te klikken om deel te nemen.",
                },
            },
            tabs: {
                dashboard: "Dashboard",
                monitoring: "Monitoring",
                data: "Gegevens",
                ivr: "IVR",
                localization: "Localisatie",
                voters: "Kiezers",
                areas: "Gebieden",
                keys: "Sleutels",
                tally: "Telling",
                tallySheetImports: "Imports van processen-verbaal",
                publish: "Publiceren",
                logs: "Logs",
                tasks: "Taken",
                events: "Geplande Gebeurtenissen",
                notifications: "Meldingen",
                reports: "Rapporten",
                approvals: "Goedkeuringen",
                cas: "Certificaten",
            },
            tally: {
                emptyHeader: "Nog geen telling.",
                title: "Telling Verkiezingsevenement",
                elections: "Verkiezingen",
                electionNumber: "Aantal Verkiezingen",
                trustees: "Trustees",
                permissionLabels: "Machtigingslabels",
                status: "Status",
                tallyType: {
                    label: "Type Telling",
                    ELECTORAL_RESULTS: "Verkiezingsresultaten",
                    INITIALIZATION_REPORT: "Initialisatierapport",
                },
                create: {
                    title: "Telling aanmaken",
                    subtitle: "Een nieuwe telling aanmaken voor dit verkiezingsevenement",
                    createTallyButton: "Telceremonie Starten",
                    createInitializationReportButton: "Initialisatierapport Genereren",
                    error: {
                        create: "Fout bij aanmaken telling",
                    },
                    success: "Telling aangemaakt",
                },
                logs: {
                    noLogs: "Geen logs beschikbaar",
                },
                notify: {
                    noKeysTally: "De telceremonie kan niet starten voordat de sleutelceremonie succesvol is voltooid.",
                    noPublication: "De telceremonie kan niet starten voordat u een publicatie aanmaakt in het tabblad Publiceren.",
                    participateNow: "U bent uitgenodigd om deel te nemen aan een telceremonie. Gelieve op de Sleutelactie van de ceremonie te klikken om deel te nemen.",
                    startDisabled: "U kunt de ceremonie niet voortzetten omdat er geen verkiezingen zijn geselecteerd of de verkiezingen niet zijn gepubliceerd.",
                    ceremonyDisabled: "U kunt de ceremonie niet voortzetten omdat de telsessie niet is verbonden of de start van de ceremonie niet is toegestaan.",
                },
            },
            importAreas: {
                title: "Gebieden Importeren",
                subtitle: "Gegevens gebieden importeren",
                areaParagraph: "Importeer gebieden met een spreadsheetbestand in CSV-formaat (Comma Separated Values).",
                importSuccess: "Gebieden succesvol geïmporteerd",
                importError: "Fout bij importeren van gebieden",
                upsert: "Gebieden 'Upserten'",
            },
            import: {
                eetitle: "Verkiezingsevenement Importeren",
                eesubtitle: "Gegevens verkiezingsevenement importeren",
                title: "Kiezers Importeren",
                subtitle: "Gegevens kiezers importeren",
                voters: "Kiezers",
                votersParagraph: "Importeer kiezers met een spreadsheetbestand in CSV-formaat (Comma Separated Values). Download hier een voorbeeld CSV-importbestand.",
                electionEventParagraph: "Importeer Verkiezingsevenementen met een JSON-bestand.",
                elections: "Verkiezingen",
                areas: "Gebieden",
                sha: "Integriteitscontrole (SHA-256)",
                cancel: "Annuleren",
                import: "Importeren",
                fileUploadSuccess: "Bestand geüpload naar server - maar nog niet geïmporteerd",
                fileUploadError: "Fout bij uploaden bestand",
                importVotersSuccess: "Import kiezers succesvol ingepland",
                importVotersError: "Fout bij importeren van kiezers",
                importElectionEventSuccess: "Verkiezingsevenement succesvol geïmporteerd",
                importElectionEventError: "Fout bij importeren verkiezingsevenement",
                shaDialog: {
                    ok: "Ja, importeren zonder integriteitscontrole",
                    cancel: "Terug",
                    title: "Importeren zonder integriteitscontrole?",
                    description: "U hebt het veld Integriteitscontrole (SHA-256) niet ingevuld. Bevestig dat u het juiste bestand importeert en dat u het wilt importeren.",
                },
                passwordDialog: {
                    title: "Ontsleutelingswachtwoord",
                    description: "Voer het wachtwoord in om het bestand te ontsleutelen",
                    label: "Wachtwoord",
                    copyPassword: "Wachtwoord Kopiëren",
                    ok: "Ok",
                },
            },
            export: {
                title: "Verkiezingsevenement Exporteren",
                subtitle: "Exporteren kan lang duren. Weet u zeker dat u records wilt exporteren?",
                encryptWithPassword: "Versleutelen met wachtwoord",
                passwordForcedNote: "Het archief wordt hoe dan ook met een wachtwoord beveiligd: rapporten, aanvragen en bulletinboardgegevens worden altijd versleuteld. Vink het vakje aan om ook ontsleutelde geheime kiezersvelden op te nemen.",
                includeVoters: "Kiezers Opnemen",
                activityLogs: "Activiteitenlogs",
                bulletinBoard: "Prikbord",
                publications: "Publicaties",
                s3Files: "S3-bestanden",
                scheduledEvents: "Geplande Gebeurtenissen",
                exportSuccess: "Verkiezingsevenement succesvol geëxporteerd",
                exportError: "Fout bij exporteren verkiezingsevenement",
                passwordTitle: "Wachtwoord",
                passwordDescription: "Wachtwoord om het bestand te ontsleutelen:",
                copiedSuccess: "Wachtwoord gekopieerd naar klembord",
                copiedError: "Fout bij kopiëren wachtwoord",
                reports: "Rapporten",
                applications: "Applicaties",
                tally: "Telling",
                certificates: "Certificaten",
            },
            taskNotification: "{{action}} is gestart. U kunt de status ervan zien in de tabel Taakuitvoering.",
        },
        electionScreen: {
            common: {
                title: "Verkiezing",
                subtitle: "Configuratie verkiezing.",
                fileLoaded: "Bestand geladen",
                noPermission: "U hebt geen toestemming om toegang te krijgen tot deze verkiezing.",
            },
            edit: {
                general: "Algemeen",
                dates: "Datums",
                votingPeriod: "Stemperiode",
                language: "Taal",
                allowed: "Toegestane stemkanalen",
                default: "Standaard",
                defaultLang: "Standaardtaal",
                receipts: "Ontvangstbewijzen",
                image: "Afbeelding",
                advanced: "Geavanceerde Configuratie",
                numAllowedVotes: "Aantal toegestane stemmen",
                reorder: "Volgorde stemmingen wijzigen",
                castVoteConfirm: "Bevestigingsvenster stem uitbrengen",
                gracePeriodPolicy: "Respijttermijn",
                allowTallyPolicy: "Telling Toestaan",
                permissionLabel: "Machtigingslabel",
                custom_filters: "Aangepaste filters",
            },
            field: {
                name: "Naam",
                language: "Taal",
                votingChannels: "Stemkanalen",
                startDateTime: "Startdatum en -tijd",
                endDateTime: "Einddatum en -tijd",
                startDateTimeWithTimezone: "Startdatum en -tijd ({{timezone}})",
                endDateTimeWithTimezone: "Einddatum en -tijd ({{timezone}})",
                scheduledOpening: "Geplande Opening",
                scheduledClosing: "Geplande Sluiting",
                alias: "Alias",
                description: "Beschrijving",
                securityConfirmationHtml: "Beveiligingsbevestiging HTML",
                ivrPrompt: "IVR-bericht",
                externalId: "Externe ID",
            },
            securityConfirmationPolicy: {
                label: "Beleid voor selectievakje van beveiligingsbevestiging",
                none: "Geen",
                mandatory: "Verplicht",
            },
            error: {
                fileError: "Fout bij uploaden bestand",
                fileLoaded: "Bestand geladen",
                endDate: "Einddatum moet na startdatum liggen",
                startDate: "Startdatum moet in de toekomst liggen",
                endDateInvalid: "Einddatum moet in de toekomst liggen",
            },
            createElectionEventSuccess: "Verkiezingsevenement aangemaakt",
            createElectionEventError: "Fout bij aanmaken verkiezingsevenement",
            tabs: {
                dashboard: "Dashboard",
                monitoring: "Monitoring",
                data: "Gegevens",
                voters: "Kiezers",
                publish: "Publiceren",
                logs: "Logs",
                approvals: "Goedkeuringen",
                tallySheets: "Tellerschema's",
            },
            gracePeriodPolicy: {
                "label": "Respijttermijnbeleid",
                "no-grace-period": "Geen respijttermijn",
                "grace-period-without-alert": "Respijttermijn zonder waarschuwing",
                "gracePeriodSecs": "Respijttermijn in seconden",
            },
            allowTallyPolicy: {
                "allowed": "Toegestaan",
                "disallowed": "Niet toegestaan",
                "requires-voting-period-end": "Vereist einde stemperiode",
            },
            initializeReportPolicy: {
                "label": "Initialisatierapportbeleid",
                "not-required": "Niet vereist",
                "required": "Vereist",
            },
            castVoteGoldLevelPolicy: {
                label: "Authenticatiebeleid 'Gold level'",
                options: {
                    "gold-level": "'Gold level' Authenticatie",
                    "no-gold-level": "Geen 'Gold level' Authenticatie",
                },
            },
            slates: {
                enable: {
                    label: "Lijsten inschakelen",
                    helper: "Als dit is ingeschakeld, kunnen kiezers een benoemde lijst kiezen en elke stemming aanpassen, ook met onafhankelijke kandidaten.",
                },
                disable: {
                    confirm: "Lijsten uitschakelen",
                    message_one: "Deze verkiezing heeft {{count}} lijst. Als je lijsten uitschakelt, wordt die bij het opslaan verwijderd.",
                    message_many: "Deze verkiezing heeft {{count}} lijsten. Als je lijsten uitschakelt, worden ze bij het opslaan verwijderd.",
                    message_other: "Deze verkiezing heeft {{count}} lijsten. Als je lijsten uitschakelt, worden ze bij het opslaan verwijderd.",
                },
                mobileCandidateLists: {
                    label: "Kandidatenlijsten op mobiel",
                    helper: "Hoe de kandidatenlijst van elke lijst op een telefoon begint: Ingeklapt of Uitgeklapt. Kiezers kunnen elke lijst altijd openen of sluiten. Op desktop worden altijd alle kandidaten getoond.",
                    options: {
                        collapsed: "Ingeklapt",
                        expanded: "Uitgeklapt",
                    },
                },
            },
            startScreenTitlePolicy: {
                label: "Titelbeleid startscherm",
                options: {
                    "election": "Verkiezingstitel",
                    "election-event": "Verkiezingsevenementtitel",
                },
            },
            consolidatedReportPolicy: {
                label: "Beleid voor geconsolideerd rapport",
                options: {
                    "generate": "Genereren",
                    "do-not-generate": "Niet genereren",
                },
            },
            declineToVotePolicy: {
                label: "Beleid voor afzien van stemmen",
                options: {
                    enabled: "Ingeschakeld",
                    disabled: "Uitgeschakeld",
                },
            },
            blankBallotsPolicy: {
                label: "Beleid voor blanco stembiljetten",
                options: {
                    enabled: "Ingeschakeld",
                    disabled: "Uitgeschakeld",
                },
            },
            votingScreenBackPolicy: {
                label: "Beleid voor de terugknop van het stemscherm",
                options: {
                    "election-selection-screen": "Ga naar het verkiezingskeuzescherm",
                    "start-screen": "Ga naar het startscherm van de verkiezing",
                },
            },
        },
        tenantScreen: {
            common: {
                title: "Tenants",
            },
            new: {
                subtitle: "Nieuwe tenant aanmaken",
            },
            createSuccess: "Tenant aangemaakt",
            createError: "Fout bij aanmaken tenant",
        },
        usersAndRolesScreen: {
            noPermissions: "U hebt geen toestemming om toegang te krijgen tot gebruikers of rollen.",
            common: {
                title: "Gebruikers en Rollen",
                subtitle: "Algemene configuratie",
                mobileNumber: "Mobiel nummer",
            },
            editPassword: {
                passwordPolicyViolation: "Het wachtwoord voldoet niet aan het Wachtwoordbeleid voor deze verkiezingsgebeurtenis. Controleer het beleid onder Gegevens verkiezingsgebeurtenis en voer een geldig wachtwoord in.",
                passwordPolicyRules: {
                    minimumLength: "De minimale wachtwoordlengte is {{count}}.",
                    maximumLength: "De maximale wachtwoordlengte is {{count}}.",
                    uppercase: "Vereiste hoofdletters: {{count}}.",
                    lowercase: "Vereiste kleine letters: {{count}}.",
                    digits: "Vereiste cijfers: {{count}}.",
                    specialCharacters: "Vereiste speciale tekens: {{count}}.",
                },
                label: "Wachtwoord wijzigen",
                temporatyLabel: "Tijdelijk",
                temporatyInfo: "Indien ingeschakeld, moet de gebruiker het wachtwoord wijzigen bij de volgende login",
            },
            users: {
                title: "Gebruikers",
                subtitle: "Gebruikersgegevens bekijken en bewerken",
                review: {
                    title: "Wijzigingen controleren",
                    subtitle: "Bevestig deze updates voordat u ze indient.",
                    confirm: "Wijzigingen bevestigen",
                    noChanges: "Geen wijzigingen om te controleren",
                    field: "Veld",
                    currentValue: "Huidige waarde",
                    newValue: "Nieuwe waarde",
                },
                edit: {
                    title: "Gebruikersgegevens",
                    subtitle: "Gebruiker bekijken en bewerken",
                },
                create: {
                    title: "Gebruiker",
                    subtitle: "Gebruiker aanmaken",
                },
                fields: {
                    "has_voted": "Gestemd",
                    "support_materials_viewed": "Ondersteunend materiaal bekeken",
                    "vote-weight": "Stemgewicht",
                    "voted-channel": "Stemkanaal",
                    "disable-comment": "Deactiveringsopmerking",
                    "username": "Gebruikersnaam",
                    "first_name": "Voornaam",
                    "last_name": "Achternaam",
                    "email": "E-mail",
                    "enabled": "Ingeschakeld",
                    "emailVerified": "E-mail geverifieerd",
                    "groups": "Groepen",
                    "attributes": "Attributen",
                    "area": "Gebied",
                    "password": "Wachtwoord",
                    "repeatPassword": "Wachtwoord herhalen",
                    "savePassword": "Wachtwoord opslaan",
                    "passwordMismatch": "Wachtwoorden moeten overeenkomen",
                    "passwordLengthValidate": "Wachtwoord moet minstens 8 tekens lang zijn",
                    "passwordUppercaseValidate": "Wachtwoord moet minstens één hoofdletter bevatten",
                    "passwordLowercaseValidate": "Wachtwoord moet minstens één kleine letter bevatten",
                    "passwordDigitValidate": "Wachtwoord moet minstens één cijfer bevatten",
                    "passwordSpecialCharValidate": "Wachtwoord moet minstens één speciaal teken bevatten",
                    "trustee": "Optreden als Trustee",
                    "permissionLabel": "Machtigingslabel",
                    "authorized-election-ids": "Verkiezingen",
                },
                delete: {
                    body: "Weet u zeker dat u deze gebruiker wilt verwijderen?",
                    bulkBody: "Weet u zeker dat u de geselecteerde gebruikers wilt verwijderen?",
                    bulkBodySelected: "De {{count}} geselecteerde gebruikers verwijderen? Dit kan niet ongedaan worden gemaakt.",
                    bulkBodyChoose: "Er zijn {{count}} gebruikers geselecteerd. U kunt in plaats daarvan alle gebruikers verwijderen die aan de huidige filters voldoen; dat kunnen er meer zijn. Dit kan niet ongedaan worden gemaakt.",
                    okSelected: "{{count}} geselecteerde verwijderen",
                    okAllMatching: "Alle overeenkomende verwijderen",
                },
                notifications: {
                    exportError: "Fout bij exporteren gebruikers",
                    deleteError: "Fout bij verwijderen gebruiker",
                    deleteSuccess: "Gebruiker verwijderd",
                    multipleDeleteSuccess: "Gebruikers verwijderd",
                },
            },
            voters: {
                voterInformationLetter: {
                    label: "Kiezersinformatiebrief",
                    generate: "Genereren",
                    confirmation: "Een Kiezersinformatiebrief voor deze kiezer genereren? Er wordt een nieuw wachtwoord toegewezen en opgenomen in een versleutelde PDF.",
                    generationStarted: "Het genereren van de Kiezersinformatiebrief is gestart",
                    generationError: "De Kiezersinformatiebrief kon niet worden gegenereerd",
                    policyNotConfigured: "Het Wachtwoordbeleid is niet geconfigureerd. Stel het in onder Gegevens verkiezingsgebeurtenis voordat u een brief genereert.",
                    policyMinimumLengthMissing: "Het Wachtwoordbeleid moet een minimale lengte bevatten voordat u een brief genereert.",
                    policyCharacterClassMissing: "Het Wachtwoordbeleid moet ten minste één tekenklasse bevatten voordat u een brief genereert.",
                },
                title: "Kiezers",
                subtitle: "Kiezersgegevens bekijken en bewerken",
                secretAttribute: {
                    storedPlaceholder: "Opgeslagen versleutelde waarde",
                    reveal: "Tonen",
                    hide: "Verbergen",
                    revealError: "Het versleutelde kiezersveld kon niet worden getoond",
                    includeInExport: "Ontsleutelde geheime kiezersvelden opnemen",
                    exportWarning: "Gevoelige export: de gedownloade CSV bevat deze velden als platte tekst.",
                    clear: "Wissen",
                    add: "Waarde toevoegen",
                    remove: "Waarde verwijderen",
                },
                review: {
                    title: "Wijzigingen controleren",
                    subtitle: "Bevestig deze updates voordat u ze indient.",
                    confirm: "Wijzigingen bevestigen",
                    noChanges: "Geen wijzigingen om te controleren",
                    field: "Veld",
                    currentValue: "Huidige waarde",
                    newValue: "Nieuwe waarde",
                },
                logs: {
                    label: "Logs van kiezer",
                },
                create: {
                    title: "Kiezer",
                    subtitle: "Kiezer aanmaken",
                },
                manualVerification: {
                    label: "Handmatig Verifiëren",
                    verify: "Deze kiezer handmatig verifiëren",
                    body: "Verifieer deze kiezer handmatig. U ontvangt een PDF met een QR-code link waarmee de kiezer kan inloggen zonder online KYC.",
                    noEmailOrPhone: "Deze kiezer kan niet handmatig worden geverifieerd omdat er geen e-mailadres of telefoonnummer aan hen is toegewezen.",
                },
                emptyHeader: "Nog geen kiezers.",
                askCreate: "Wilt u er een aanmaken?",
                errors: {
                    editError: "Fout bij bewerken kiezer",
                    editErrorReason: "Fout bij bewerken kiezer: {{reason}}",
                    editSuccess: "Kiezer bewerkt",
                    createError: "Fout bij aanmaken kiezer",
                    createErrorReason: "Fout bij aanmaken kiezer: {{reason}}",
                    createSuccess: "Kiezer aangemaakt",
                    attribute: {
                        invalidNamed: '"{{field}}" is geweigerd: {{constraint}}',
                        fieldsToCorrect: "Sommige velden moeten worden gecorrigeerd voordat u opslaat",
                        hintBetween: "Tussen {{min}} en {{max}} tekens",
                        hintMin: "Minimaal {{min}} tekens",
                        hintMax: "Maximaal {{max}} tekens",
                        andMore: "en nog {{count}}",
                        invalidLength: '"{{field}}" moet tussen {{min}} en {{max}} tekens bevatten',
                        tooShort: '"{{field}}" moet minimaal {{min}} tekens bevatten',
                        tooLong: '"{{field}}" mag maximaal {{max}} tekens bevatten',
                        required: '"{{field}}" is verplicht',
                        invalidEmail: '"{{field}}" moet een geldig e-mailadres zijn',
                        invalidFormat: '"{{field}}" heeft niet de verwachte indeling',
                        invalid: '"{{field}}" heeft een ongeldige waarde',
                    },
                    createPasswordError: "Kiezer aangemaakt, maar het wachtwoord kon niet worden ingesteld",
                    createPasswordErrorReason: "Kiezer aangemaakt, maar het wachtwoord kon niet worden ingesteld: {{reason}}",
                },
                delete: {
                    body: "Weet u zeker dat u deze kiezer wilt verwijderen?",
                    bulkBody: "Weet u zeker dat u de geselecteerde kiezers wilt verwijderen?",
                    bulkBodySelected: "De {{count}} geselecteerde kiezers verwijderen? Dit kan niet ongedaan worden gemaakt.",
                    bulkBodyChoose: "Er zijn {{count}} kiezers geselecteerd. U kunt in plaats daarvan alle kiezers verwijderen die aan de huidige filters voldoen; dat kunnen er meer zijn. Dit kan niet ongedaan worden gemaakt.",
                    okSelected: "{{count}} geselecteerde verwijderen",
                    okAllMatching: "Alle overeenkomende verwijderen",
                },
                notifications: {
                    exportError: "Fout bij exporteren kiezers",
                    deleteError: "Fout bij verwijderen kiezer",
                    deleteSuccess: "Kiezer verwijderd",
                    multipleDeleteSuccess: "Kiezers verwijderd",
                    manualVerificationError: "Fout bij handmatig verifiëren van de kiezer",
                    manualVerificationSuccess: "Kiezer succesvol handmatig geverifieerd, PDF downloaden...",
                },
            },
            roles: {
                title: "Rollen",
                edit: {
                    title: "Rolgegevens",
                    subtitle: "Rol bekijken en bewerken",
                },
                create: {
                    title: "Rol",
                    subtitle: "Rol aanmaken",
                },
                errors: {
                    createError: "Fout bij aanmaken rol",
                    createSuccess: "Rol aangemaakt",
                },
                fields: {
                    name: "Naam",
                },
                delete: {
                    body: "Weet u zeker dat u deze rol wilt verwijderen?",
                },
                notifications: {
                    deleteError: "Fout bij verwijderen rol",
                    deleteSuccess: "Rol verwijderd",
                    permissionEditError: "Fout bij bewerken machtiging",
                    permissionEditSuccess: "Machtiging bewerkt",
                },
            },
            permissions: {
                "voter-information-letter": "Kiezersinformatiebrief genereren",
                "admin-user": "Beheerder Gebruiker",
                "admin-dashboard-view": "Beheerdersdashboard Bekijken",
                "application-export": "Applicatie Exporteren",
                "application-import": "Applicatie Importeren",
                "tenant-create": "Tenant Aanmaken",
                "tenant-read": "Tenant Lezen",
                "tenant-write": "Tenant Bewerken",
                "tenant-delete": "Tenant Verwijderen",
                "election-event-create": "Verkiezingsevenement Aanmaken",
                "election-event-read": "Verkiezingsevenement Lezen",
                "election-event-write": "Verkiezingsevenement Bewerken",
                "keycloak-realm-attributes-read": "Keycloak realm-attributen lezen",
                "keycloak-realm-attributes-write": "Keycloak realm-attributen bewerken",
                "election-event-delete": "Verkiezingsevenement Verwijderen",
                "voter-create": "Kiezer Aanmaken",
                "voter-read": "Kiezer Lezen",
                "voter-write": "Kiezer Bewerken",
                "voter-secret-attribute-read": "Geheime Kiezersvelden Tonen",
                "voter-secret-attribute-write": "Geheime Kiezersvelden Bewerken",
                "user-create": "Gebruiker Aanmaken",
                "user-read": "Gebruiker Lezen",
                "user-write": "Gebruiker Bewerken",
                "user-permission-create": "Gebruikersmachtiging Aanmaken",
                "user-permission-read": "Gebruikersmachtiging Lezen",
                "user-permission-write": "Gebruikersmachtiging Bewerken",
                "role-create": "Rol Aanmaken",
                "role-read": "Rol Lezen",
                "role-write": "Rol Bewerken",
                "role-assign": "Rol Toewijzen",
                "communication-template-create": "Communicatiesjabloon Aanmaken",
                "communication-template-read": "Communicatiesjabloon Lezen",
                "communication-template-write": "Communicatiesjabloon Bewerken",
                "notification-read": "Melding Lezen",
                "notification-write": "Melding Bewerken",
                "notification-send": "Melding Verzenden",
                "area-read": "Gebied Lezen",
                "area-write": "Gebied Bewerken",
                "election-state-write": "Verkiezingsstatus Bewerken",
                "election-type-create": "Verkiezingstype Aanmaken",
                "election-type-read": "Verkiezingstype Lezen",
                "election-type-write": "Verkiezingstype Bewerken",
                "voting-channel-read": "Stemkanaal Lezen",
                "voting-channel-write": "Stemkanaal Bewerken",
                "trustee-create": "Trustee Aanmaken",
                "trustee-read": "Trustee Lezen",
                "trustee-write": "Trustee Bewerken",
                "tally-read": "Telling Lezen",
                "tally-start": "Telling Starten",
                "tally-write": "Telling Bewerken",
                "tally-results-read": "Telresultaten Lezen",
                "publish-read": "Publicatie Lezen",
                "publish-write": "Publicatie Bewerken",
                "publish-results-read": "Resultatenpublicatie Lezen",
                "publish-results-write": "Resultatenpublicatie Bewerken",
                "logs-read": "Logs Lezen",
                "tasks-read": "Taakuitvoering Lezen",
                "keys-read": "Sleutels Lezen",
                "document-upload": "Documenten Uploaden",
                "document-download": "Documenten Downloaden",
                "document-password-read": "Documentwachtwoorden Lezen",
                "tally-sheet-create": "Telblad Aanmaken",
                "tally-sheet-import-create": "Telformulierimport aanmaken",
                "tally-sheet-import-review": "Telformulierimport beoordelen",
                "tally-sheet-import-view": "Telformulierimport bekijken",
                "tally-recount-execute": "Resultaten hertellen uitvoeren",
                "trustee-ceremony": "Trustee Ceremonie",
                "tally-sheet-review": "Telformulier beoordelen",
                "tally-sheet-view": "Telblad Bekijken",
                "admin-ceremony": "Beheerdersceremonie",
                "tally-sheet-delete": "Telblad Verwijderen",
                "cast-vote-read": "Uitgebrachte Stemmen Lezen",
                "document-read": "Documenten Lezen",
                "document-write": "Documenten Bewerken",
                "support-material-read": "Ondersteunend Materiaal Lezen",
                "support-material-write": "Ondersteunend Materiaal Bewerken",
                "miru-create": "Miru Aanmaken",
                "miru-download": "Miru Downloaden",
                "miru-send": "Miru Verzenden",
                "miru-sign": "Miru Ondertekenen",
                "contest-write": "Stemming Bewerken",
                "contest-read": "Stemming Lezen",
                "candidate-write": "Kandidaat Bewerken",
                "candidate-read": "Kandidaat Lezen",
                "permission-label-write": "Machtigingslabel Bewerken",
                "scheduled-event-write": "Geplande Gebeurtenissen Bewerken",
                "contest-create": "Stemming Aanmaken",
                "contest-delete": "Stemming Verwijderen",
                "candidate-create": "Kandidaat Aanmaken",
                "candidate-delete": "Kandidaat Verwijderen",
                "election-create": "Verkiezing Aanmaken",
                "election-read": "Verkiezing Lezen",
                "election-write": "Verkiezing Bewerken",
                "election-delete": "Verkiezing Verwijderen",
                "election-event-archive": "Verkiezingsevenement Archiveren",
                "election-data-tab": "Tabblad Verkiezingsgegevens Bekijken",
                "election-event-areas-tab": "Tabblad Gebieden Verkiezingsevenement Bekijken",
                "election-event-data-tab": "Tabblad Gegevens Verkiezingsevenement Bekijken",
                "election-event-keys-tab": "Tabblad Sleutels Verkiezingsevenement Bekijken",
                "election-event-logs-tab": "Tabblad Logs Verkiezingsevenement Bekijken",
                "election-event-publish-tab": "Tabblad Publicatie Verkiezingsevenement Bekijken",
                "election-event-reports-tab": "Tabblad Rapporten Verkiezingsevenement Bekijken",
                "election-event-scheduled-tab": "Tabblad Planning Verkiezingsevenement Bekijken",
                "election-event-tally-tab": "Tabblad Telling Verkiezingsevenement Bekijken",
                "election-event-tasks-tab": "Tabblad Taken Verkiezingsevenement Bekijken",
                "election-event-voters-tab": "Tabblad Kiezers Verkiezingsevenement Bekijken",
                "election-publish-tab": "Tabblad Verkiezingspublicatie Bekijken",
                "election-voters-tab": "Tabblad Kiezers Verkiezing Bekijken",
                "report-write": "Rapporten Bewerken",
                "report-read": "Rapporten Lezen",
                "users-menu": "Menu Gebruikers en Rollen Bekijken",
                "settings-menu": "Menu Instellingen Bekijken",
                "templates-menu": "Menu Sjablonen Bekijken",
                "settings-election-types-tab": "Tabblad Instellingen Verkiezingstypes Bekijken",
                "settings-voting-channels-tab": "Tabblad Instellingen Stemkanalen Bekijken",
                "settings-templates-tab": "Tabblad Instellingen Sjablonen Bekijken",
                "settings-languages-tab": "Tabblad Instellingen Talen Bekijken",
                "settings-localization-tab": "Tabblad Instellingen Localisatie Bekijken",
                "settings-look-feel-tab": "Tabblad Instellingen Look & Feel Bekijken",
                "settings-trustees-tab": "Tabblad Instellingen Trustees Bekijken",
                "settings-countries-tab": "Tabblad Instellingen Landen Bekijken",
                "voter-import": "Kiezer Importeren",
                "ee-voters-columns": "Kolommen Kiezers Verkiezingsevenement Bekijken",
                "voter-manually-verify": "Kiezer Handmatig Verifiëren",
                "ee-voters-logs": "Logs Kiezers Verkiezingsevenement Bekijken",
                "voter-export": "Kiezer Exporteren",
                "ee-voters-filters": "Filters Kiezers Verkiezingsevenement Bekijken",
                "voter-delete": "Kiezer Verwijderen",
                "voter-change-password": "Wachtwoord Kiezer Wijzigen",
                "election-event-localization-selector": "Localisatieselectie Verkiezingsevenement",
                "localization-create": "Localisatie Aanmaken",
                "localization-read": "Localisatie Lezen",
                "localization-write": "Localisatie Bewerken",
                "localization-delete": "Localisatie Verwijderen",
                "area-create": "Gebied Aanmaken",
                "area-delete": "Gebied Verwijderen",
                "area-export": "Gebied Exporteren",
                "area-import": "Gebied Importeren",
                "area-upsert": "Gebied 'Upserten'",
                "election-event-areas-columns": "Kolommen Gebieden Verkiezingsevenement",
                "election-event-areas-filters": "Filters Gebieden Verkiezingsevenement",
                "election-event-tasks-back-button": "Terug naar Taken Verkiezingsevenement",
                "election-event-tasks-columns": "Kolommen Taken Verkiezingsevenement",
                "election-event-tasks-filters": "Filters Taken Verkiezingsevenement",
                "task-export": "Taken Exporteren",
                "application-read": "Applicatie Lezen",
                "application-write": "Applicatie Bewerken",
                "logs-export": "Logs Exporteren",
                "election-event-logs-columns": "Kolommen Logs Verkiezingsevenement",
                "election-events-logs-filters": "Filters Logs Verkiezingsevenement",
                "election-event-scheduled-event-columns": "Kolommen Geplande Gebeurtenissen Verkiezingsevenement",
                "scheduled-event-create": "Geplande Gebeurtenis Aanmaken",
                "scheduled-event-delete": "Geplande Gebeurtenis Verwijderen",
                "election-event-reports-columns": "Kolommen Rapporten Verkiezingsevenement",
                "report-create": "Rapport Aanmaken",
                "report-delete": "Rapport Verwijderen",
                "report-generate": "Rapport Genereren",
                "report-preview": "Rapport Voorbeeldweergave",
                "monitor-authenticated-voters": "Monitoring Geauthenticeerde Kiezers",
                "monitor-all-approve-disapprove-voters": "Monitoring Goedgekeurde/Afgekeurde Kiezers Lezen",
                "monitor-automatic-approve-disapprove-voters": "Monitoring Automatisch Goedgekeurde/Afgekeurde Kiezers Lezen",
                "monitor-manually-approve-disapprove-voters": "Monitoring Handmatig Goedgekeurde/Afgekeurde Kiezers Lezen",
                "monitor-enrolled-overseas-voters": "Monitoring Ingeschreven Buitenlandse Kiezers Lezen",
                "monitor-posts-already-closed-voting": "Monitoring Posten Reeds Gesloten Stemming Lezen",
                "monitor-posts-already-generated-election-results": "Monitoring Posten Reeds Gegenereerde Verkiezingsresultaten Lezen",
                "monitor-posts-already-opened-voting": "Monitoring Posten Reeds Geopende Stemming Lezen",
                "monitor-posts-already-started-counting-votes": "Monitoring Posten Reeds Gestart Stemmen Tellen Lezen",
                "monitor-posts-initialized-the-system": "Monitoring Posten Geïnitialiseerd Systeem Lezen",
                "monitor-posts-started-voting": "Monitoring Posten Gestart Stemmen Lezen",
                "monitor-posts-transmitted-results": "Monitoring Posten Verzonden Resultaten Lezen",
                "monitor-voters-voted-test-election": "Monitoring Kiezers Gestemd Testverkiezing Lezen",
                "monitor-voters-who-voted": "Monitoring Kiezers Die Gestemd Hebben Lezen",
                "election-event-publish-preview": "Voorbeeldweergave Publicatie Verkiezingsevenement",
                "election-event-publish-back-button": "Terug naar Publicatie Verkiezingsevenement",
                "election-event-publish-columns": "Kolommen Publicatie Verkiezingsevenement",
                "election-event-publish-filters": "Filters Publicatie Verkiezingsevenement",
                "publish-create": "Publicatie Aanmaken",
                "publish-regenerate": "Publicatie Regenereren",
                "publish-export": "Publicatie Exporteren",
                "publish-start-voting": "Stemmen Starten",
                "publish-pause-voting": "Stemmen Pauzeren",
                "publish-stop-voting": "Stemmen Stoppen",
                "publish-changes": "Wijzigingen Publiceren",
                "election-event-publish-view": "Publicatie Verkiezingsevenement Bekijken",
                "election-event-keys-columns": "Kolommen Sleutels Verkiezingsevenement",
                "create-ceremony": "Ceremonie Aanmaken",
                "export-ceremony": "Ceremonie Exporteren",
                "election-event-tally-columns": "Kolommen Telling Verkiezingsevenement",
                "election-event-tally-back-button": "Terug naar Telling Verkiezingsevenement",
                "transmition-ceremony": "Transmissieceremonie",
                "admin-ip-address-view": "IP-adres Bekijken (Admin)",
                "election-approvals-tab": "Tabblad Goedkeuringen Verkiezing Bekijken",
                "election-event-approvals-tab": "Tabblad Goedkeuringen Verkiezingsevenement Bekijken",
                "election-ip-address-view": "IP-adres Verkiezing Bekijken",
                "election-dashboard-tab": "Tabblad Dashboard Verkiezing Bekijken",
                "trustees-export": "Trustees Exporteren",
                "user-import": "Gebruikers Importeren",
                "voter-voted-edit": "Kiezers die gestemd hebben bewerken",
                "voter-email-tlf-edit": "E-mail/telefoonvelden kiezers bewerken",
                "cloudflare-write": "Regels Landblokkering in Cloudflare Bewerken",
                "transmission-report-generate": "Transmissierapport Genereren",
                "google-meet-link": "Google Meet Link Genereren",
                "service-account": "Serviceaccount",
                "datafix-account": "Datafix-account",
                "gold": "Goud",
                "silver": "Zilver",
                "election-event-ivr-tab": "IVR van verkiezingsevenement bekijken",
                "election-event-cas-tab": "CAS van verkiezingsevenement bekijken",
                "ca-read": "Certificeringsinstanties lezen",
                "ca-write": "Certificeringsinstanties bewerken",
                "generate-preview": "Voorbeeld genereren",
                "preview-read": "Voorbeeld lezen",
                "tally-resolution-submit": "Tellingbesluit indienen",
                "phone-blacklist-read": "Telefoonblokkadelijst lezen",
                "phone-blacklist-create": "Vermeldingen aan de telefoonblokkadelijst toevoegen",
                "phone-blacklist-update": "Vermeldingen in de telefoonblokkadelijst bewerken",
                "phone-blacklist-delete": "Vermeldingen uit de telefoonblokkadelijst verwijderen",
                "election-event-voter-list-reconciliation": "Kiezerslijst van verkiezingsevenement afstemmen",
            },
        },
        generalSettingsScreen: {
            body: "Schakel talen in het systeem in. Alleen talen die hier zijn ingeschakeld, zijn beschikbaar voor verkiezingsevenementen.",
        },
        eventsScreen: {
            title: "Geplande Gebeurtenissen",
            subtitle: "Beheert de configuratie van de automatische uitvoering van gebeurtenissen zoals de start of het einde van de stemperiode.",
            messages: {
                createSuccess: "Geplande gebeurtenis succesvol aangemaakt",
                createError: "Fout bij aanmaken geplande gebeurtenis",
                editSuccess: "Geplande gebeurtenis succesvol bewerkt",
                editError: "Fout bij bewerken geplande gebeurtenis",
                onlineWithEarlyVoting: "Een startplanning kan online stemmen en vervroegd stemmen niet tegelijk openen: vervroegd stemmen moet vóór online stemmen beginnen.",
            },
            eventType: {
                label: "Type",
                ALLOW_INIT_REPORT: "Initialisatierapport Toestaan",
                START_VOTING_PERIOD: "Start Stemperiode",
                END_VOTING_PERIOD: "Einde Stemperiode",
                ALLOW_VOTING_PERIOD_END: "Einde Stemperiode Toestaan",
                START_ENROLLMENT_PERIOD: "Start Inschrijvingsperiode",
                END_ENROLLMENT_PERIOD: "Einde Inschrijvingsperiode",
                START_LOCKDOWN_PERIOD: "Start Vergrendelingsperiode",
                END_LOCKDOWN_PERIOD: "Einde Vergrendelingsperiode",
                ALLOW_TALLY: "Telling Toestaan",
            },
            election: {
                label: "Verkiezing",
            },
            empty: {
                header: "Nog geen geplande gebeurtenissen.",
                body: "Wilt u er een aanmaken?",
                button: "Geplande Gebeurtenis Aanmaken",
            },
            create: {
                title: "Geplande Gebeurtenis Aanmaken",
                subtitle: "Een nieuwe configuratie voor geplande gebeurtenissen aanmaken.",
            },
            edit: {
                title: "Geplande Gebeurtenis Bewerken",
                subtitle: "Configuratie geplande gebeurtenis bewerken.",
                delete: "Weet u zeker dat u deze geplande gebeurtenis wilt verwijderen?",
            },
            fields: {
                electionId: "Verkiezing",
                eventProcessor: "Type",
                stoppedAt: "Gestopt op",
                scheduledDate: "Gepland op",
            },
        },
        reportsScreen: {
            title: "Rapporten",
            subtitle: "Rapporten genereren voor de verkiezingsevenementen",
            messages: {
                createSuccess: "Rapport succesvol aangemaakt",
                createError: "Fout bij aanmaken rapport",
                submitError: "Fout bij indienen rapport",
                updateSuccess: "Rapport succesvol bijgewerkt",
                passwordMismatch: "Wachtwoord en bevestig wachtwoord komen niet overeen. Zorg ervoor dat beide velden hetzelfde wachtwoord bevatten.",
                incorectPassword: "Incorrect wachtwoord",
                decryptFileTitle: "Hoe het bestand te ontsleutelen",
                decryptInstructions: "1. '-in': Het pad naar het versleutelde bestand.\n2. '-out': Het pad waar het ontsleutelde bestand wordt opgeslagen.\n3. '-pass': Het wachtwoord dat is gebruikt om het bestand te versleutelen.\n",
                encryptSuccess: "Rapportversleuteling succesvol ingesteld",
                encryptError: "Fout bij het instellen van rapportversleuteling",
            },
            reportType: {
                BALLOT_RECEIPT: "Ontvangstbewijs Stembiljet",
                ELECTORAL_RESULTS: "Verkiezingsresultaten",
                MANUAL_VERIFICATION: "Handmatige Verificatie",
                PARTICIPATION_REPORT: "Participatierapport",
                STATISTICAL_REPORT: "Statistisch Rapport",
                OVCS_EVENTS: "Monitoring Stemmen Buitenland - OVCS Gebeurtenissen",
                AUDIT_LOGS: "Auditlogs",
                ACTIVITY_LOG: "Activiteitenlog",
                STATUS: "Status",
                OVCS_INFORMATION: "OVCS Informatie",
                OVERSEAS_VOTERS: "Lijst van buitenlandse kiezers",
                OV_USERS_WHO_VOTED: "Lijst van buitenlandse kiezers die gestemd hebben",
                OV_WITH_VOTING_STATUS: "Lijst van buitenlandse kiezers met stemstatus",
                OVCS_STATISTICS: "Monitoring Stemmen Buitenland - OVCS Statistieken",
                PRE_ENROLLED_OV_BUT_DISAPPROVED: "Lijst van buitenlandse kiezers die vooraf zijn ingeschreven maar afgekeurd",
                PRE_ENROLLED_OV_SUBJECT_TO_MANUAL_VALIDATION: "Lijst van buitenlandse kiezers die vooraf zijn ingeschreven maar onderhevig aan handmatige validatie",
            },
            reportEncryptionPolicy: {
                title: "Versleutelingsbeleid",
                UNENCRYPTED: "Niet versleuteld",
                CONFIGURED_PASSWORD: "Geconfigureerd Wachtwoord",
            },
            empty: {
                header: "Nog geen rapporten.",
                body: "Wilt u er een aanmaken?",
                button: "Rapport Aanmaken",
            },
            create: {
                title: "Rapport Aanmaken",
                subtitle: "Een nieuwe rapportconfiguratie aanmaken.",
            },
            edit: {
                title: "Rapport Bewerken",
                subtitle: "Rapportconfiguratie bewerken.",
                delete: "Weet u zeker dat u dit rapport wilt verwijderen?",
            },
            fields: {
                electionId: "Verkiezing",
                template: "Sjabloon",
                reportType: "Rapporttype",
                repeatable: "Herhaalbaar",
                cronExpression: "Cron Expressie",
                emailRecipients: "E-mailontvangers",
                emailRecipientsPlaceholder: "Typ e-mailadres en druk op Enter",
            },
            delete: {
                body: "Weet u zeker dat u dit rapport wilt verwijderen?",
            },
            actions: {
                generate: "Genereren",
                delete: "Verwijderen",
                edit: "Bewerken",
                preview: "Voorbeeldweergave",
            },
        },
        googleMeet: {
            title: "Google Meet Link Genereren",
            generateButton: "Meet Genereren",
            meetingTitle: "Vergadertitel",
            description: "Beschrijving (Optioneel)",
            startDate: "Startdatum",
            startTime: "Starttijd",
            duration: "Duur (minuten)",
            attendeeEmails: "Emails Deelnemers",
            attendeeEmailHelp: "Komma-gescheiden emails voor vergaderdeelnemers",
            note: "Opmerking: Dit zal een agenda-evenement aanmaken in uw Google Calendar met een Google Meet link. U moet inloggen op uw Google account.",
            success: "Google Meet Link Succesvol Gegenereerd!",
            copy: "Kopiëren naar klembord",
            copied: "Link gekopieerd naar klembord!",
            instructions: "Deel deze link met deelnemers om deel te nemen aan de vergadering. Het agenda-evenement is toegevoegd aan uw Google Calendar.",
            generating: "Genereren...",
            generate: "Meet Link Genereren",
        },
        common: {
            export: "Exporteren kan lang duren. Weet u zeker dat u records wilt exporteren?",
            resources: {
                electionEvent: "Verkiezingsevenement",
                election: "Verkiezing",
                contest: "Stemming",
                candidate: "Kandidaat",
                noResult: {
                    askCreate: "Wilt u er een aanmaken?",
                },
            },
            label: {
                add: "Toevoegen",
                actions: "Acties",
                create: "Aanmaken",
                delete: "Verwijderen",
                archive: "Archiveren",
                unarchive: "Dearchiveren",
                cancel: "Annuleren",
                edit: "Bewerken",
                yes: "Ja",
                no: "Nee",
                save: "Opslaan",
                close: "Sluiten",
                back: "Terug",
                next: "Volgende",
                warning: "Waarschuwing",
                json: "Voorbeeldweergave",
                noResult: "Geen resultaat",
                import: "Importeren",
                export: "Exporteren",
                loadingData: "Gegevens laden...",
                exportFormat: "Exporteren in {{format}}-formaat - Resultaten van '{{item}}",
                allResults: "verkiezingsevenement",
                globalAreaResults: "alle gebieden",
                title: "Titel",
                subtitle: "Ondertitel",
                kind: "Bestandstype",
                filter: "Aangepaste Filters",
                approve: "Goedkeuren",
                continue: "Doorgaan",
                logout: "Uitloggen",
                selectTenant: "Huurder selecteren",
                processing: "Bezig met verwerken...",
                tenantName: "Naam van de huurder",
            },
            language: {
                es: "Spaans",
                en: "Engels",
                fr: "Frans",
                cat: "Valenciaans",
                tl: "Tagalog",
                gl: "Galicisch",
                nl: "Nederlands",
                eu: "Euskera",
            },
            channel: {
                online: "Online",
                kiosk: "Kiosk",
                early_voting: "Vroeg stemmen",
                telephone: "Telefonisch stemmen",
                other: "Overig",
            },
            message: {
                delete: "Weet u zeker dat u dit item wilt verwijderen?",
                continueOrLogout: "Wil je doorgaan of uitloggen?",
            },
        },
        createResource: {
            electionEvent: "Een Verkiezingsevenement aanmaken",
            election: "Een Verkiezing aanmaken",
            contest: "Een Stemming aanmaken",
            candidate: "Een Kandidaat aanmaken",
            slate: "Een Lijst maken",
        },
        importResource: {
            electionEvent: "Een Verkiezingsevenement importeren",
            election: "Een Verkiezing importeren",
            contest: "Een Stemming importeren",
            candidate: "Een Kandidaat importeren",
            ImportHashMismatch: "Hashes komen niet overeen. Integriteitscontrole mislukt.",
        },
        sideMenu: {
            electionEvents: "Verkiezingsevenementen",
            search: "Zoeken",
            usersAndRoles: "Gebruikers en Rollen",
            logs: "Logs",
            settings: "Instellingen",
            help: "Help",
            templates: "Sjablonen",
            active: "Actief",
            archived: "Gearchiveerd",
            addResource: {
                electionEvent: "Een Verkiezingsevenement aanmaken",
                election: "Een Verkiezing aanmaken",
                contest: "Een Stemming aanmaken",
                candidate: "Een Kandidaat aanmaken",
            },
            menuActions: {
                archive: {
                    electionEvent: "Dit Verkiezingsevenement archiveren",
                },
                unarchive: {
                    electionEvent: "Dit Verkiezingsevenement dearchiveren",
                    election: "Deze verkiezing dearchiveren",
                    contest: "Deze Stemming dearchiveren",
                    candidate: "Deze Kandidaat dearchiveren",
                },
                remove: {
                    electionEvent: "Dit Verkiezingsevenement verwijderen",
                    election: "Deze Verkiezing verwijderen",
                    contest: "Deze Stemming verwijderen",
                    candidate: "Deze Kandidaat verwijderen",
                    slate: "Deze Lijst verwijderen",
                },
                messages: {
                    confirm: {
                        archive: "Weet u zeker dat u dit item wilt archiveren?",
                        unarchive: "Weet u zeker dat u dit item wilt dearchiveren?",
                        delete: "Weet u zeker dat u dit item wilt verwijderen?",
                    },
                    notification: {
                        success: {
                            archive: "Het item is gearchiveerd",
                            unarchive: "Het item is gedearchiveerd",
                            delete: "Het item is verwijderd",
                            reloading: "Wacht. De pagina wordt binnen enkele ogenblikken opnieuw geladen.",
                        },
                        error: {
                            archive: "Fout bij het archiveren van dit item",
                            unarchive: "Fout bij het dearchiveren van dit item",
                            delete: "Fout bij het verwijderen van dit item",
                        },
                    },
                },
            },
        },
        candidateScreen: {
            common: {
                subtitle: "Configuratie kandidaat.",
            },
            edit: {
                externalId: "Externe ID",
                general: "Algemeen",
                type: "Type",
                image: "Afbeelding",
                isDisabled: "Uitgeschakeld",
                isExplicitInvalid: "Ongeldige Stem",
                isExplicitBlank: "Blanco Stem",
                isCategoryList: "Categorielijst",
                isWriteIn: "Inschrijf",
            },
            field: {
                name: "Naam",
                alias: "Alias",
                description: "Beschrijving",
            },
            options: {
                "candidate": "Kandidaat",
                "option": "Optie",
                "write-in": "Inschrijf",
                "open-list": "Open Lijst",
                "closed-list": "Gesloten Lijst",
                "semi-open-list": "Semi-open Lijst",
                "invalid-vote": "Ongeldige Stem",
                "blank-vote": "Blanco Stem",
            },
            invalidVotePosition: {
                label: "Positie van Ongeldige Stem",
                null: "Geen (Standaard)",
                top: "Boven",
                bottom: "Onder",
            },
            error: {},
            createCandidateSuccess: "Kandidaat aangemaakt",
            createCandidateError: "Fout bij aanmaken kandidaat",
        },
        slateScreen: {
            common: {
                subtitle: "Lijstconfiguratie.",
                newSlate: "Nieuwe lijst",
                notFound: "Deze lijst bestaat niet.",
            },
            tabs: {
                data: "Gegevens",
            },
            edit: {
                general: "Algemeen",
                members: "Leden",
            },
            field: {
                name: "Naam",
                alias: "Alias",
                description: "Beschrijving",
                externalId: "Externe ID",
            },
            members: {
                helper: "Wijs per stemming kandidaten toe tot het maximumaantal. Laat een stemming leeg als deze lijst daar niemand voordraagt. Kandidaten die op geen enkele lijst staan, verschijnen in die stemming als Onafhankelijk.",
                contest: "Stemming",
                candidate: "Kandidaat",
                noCandidate: "Geen kandidaat",
            },
            messages: {
                saved: "Lijst opgeslagen",
                invalid: "De lijst kan niet worden opgeslagen. Los de onderstaande problemen op.",
                error: "De lijst kon niet worden opgeslagen.",
                unreadable: "De lijstconfiguratie van de verkiezing kan niet worden gelezen.",
            },
        },
        contestScreen: {
            common: {
                subtitle: "Configuratie stemming.",
            },
            edit: {
                externalId: "Externe ID",
                general: "Algemeen",
                type: "Type",
                image: "Afbeelding",
                system: "Stemsysteem Stembiljet",
                design: "Ontwerp Stembiljet",
                reorder: "Volgorde kandidaten wijzigen",
                policies: "Beleidsregels",
            },
            field: {
                name: "Naam",
                alias: "Alias",
                description: "Beschrijving",
            },
            options: {
                "non-preferential": "Niet-preferentieel",
                "plurality-at-large": "Meerderheidsstelsel (meervoudig)",
                "instant-runoff": "Instant-runoff stemmen",
                "random": "Willekeurig",
                "external-procedure": "Externe procedure",
                "custom": "Aangepast",
                "alphabetical": "Alfabetisch",
            },
            tieBreakingPolicy: {
                label: "Beleid voor gelijkspel",
            },
            auditButtonConfig: {
                "label": "Weergaveopties Auditknop",
                "show": "Tonen",
                "not-show": "Niet Tonen",
                "show-in-help": "Tonen in Helpvenster",
            },
            underVotePolicy: {
                "label": "Beleid Onderstemmen",
                "allowed": "Toegestaan",
                "warn-only-in-review": "Waarschuwen bij Controle",
                "warn": "Waarschuwen",
                "warn-and-alert": "Waarschuwen en Melden",
                "warn-and-confirm-in-review": "Waarschuwen en Bevestigen bij Controle",
            },
            invalidVotePolicy: {
                "label": "Beleid Ongeldige Stem",
                "allowed": "Toegestaan",
                "warn": "Waarschuwen",
                "warn-invalid-implicit-and-explicit": "Waarschuwen bij Impliciet en Expliciet Ongeldig",
                "not-allowed": "Niet Toegestaan",
                "allowed-with-exclusive-explicit": "Toegestaan met Exclusief Expliciet Ongeldig",
            },
            candidatesIconCheckboxPolicy: {
                "label": "Vorm icoon selectievakje kandidaten",
                "square-checkbox": "Vierkant Selectievakje",
                "round-checkbox": "Rond Selectievakje",
            },
            checkableListPolicy: {
                "allow-selecting-candidates-and-lists": "Kandidaten en Lijsten",
                "allow-selecting-candidates": "Alleen Kandidaten",
                "allow-selecting-lists": "Alleen Lijsten",
                "disabled": "Uitgeschakeld",
            },
            collapsibleListsPolicy: {
                "label": "Inklapbare lijsten",
                "disabled": "Uitgeschakeld",
                "enabled-expanded": "Ingeschakeld (start uitgevouwen)",
                "enabled-collapsed": "Ingeschakeld (start ingeklapt)",
            },
            blankVotePolicy: {
                "label": "Beleid Blanco Stem",
                "allowed": "Toegestaan",
                "warn-only-in-review": "Waarschuwen bij Controle",
                "warn": "Waarschuwen",
                "not-allowed": "Niet Toegestaan",
            },
            overVotePolicy: {
                "label": "Beleid Overstemmen",
                "allowed": "Toegestaan",
                "allowed-with-msg": "Toegestaan met Waarschuwing",
                "allowed-with-msg-and-alert": "Toegestaan met Waarschuwing en Melding",
                "not-allowed-with-msg-and-alert": "Niet Toegestaan met Waarschuwing en Melding",
                "not-allowed-with-msg-and-disable": "Niet Toegestaan met Waarschuwing en Verdere Selecties Uitschakelen",
            },
            duplicatedRankPolicy: {
                "label": "Ongeldige stem - Beleid Gedupliceerde Rang",
                "allowed-warn-and-dialog": "Toon waarschuwing en dialoog (kiezer kan doorgaan)",
                "not-allowed-warn-and-dialog": "Toon waarschuwing en dialoog (kiezer mag niet doorgaan)",
            },
            preferenceGapsPolicy: {
                "label": "Ongeldige stem - Beleid Overgeslagen Rangen",
                "allowed-warn-and-dialog": "Toon waarschuwing en dialoog (kiezer kan doorgaan)",
                "not-allowed-warn-and-dialog": "Toon waarschuwing en dialoog (kiezer mag niet doorgaan)",
            },
            paginationPolicy: {
                label: "Paginanaam",
            },
            isAcclaimed: {
                label: "Bij acclamatie beslist",
                helperText: "Kiezers zien deze stemming maar kunnen niets selecteren, er wordt niets geregistreerd en alle kandidaten worden als winnaar met nul stemmen gerapporteerd. Stel dit in voordat stembiljetten worden gepubliceerd: het later wijzigen maakt reeds uitgebrachte stemmen ongeldig.",
            },
            allowWriteins: {
                label: "Handgeschreven kandidaten toestaan",
            },
            maxVotes: {
                helperText: "Maximaal aantal kandidaten dat een kiezer kan selecteren (niet-preferentieel stemmen).",
                helperTextPreferential: "Hoogste beschikbare rangpositie voor kiezers (bijv. '5' staat rangen 1–5 toe). Moet minimaal gelijk zijn aan het aantal te rangschikken kandidaten (preferentieel stemmen).",
            },
            error: {},
            createContestSuccess: "Stemming aangemaakt",
            createContestError: "Fout bij het aanmaken van de stemming",
        },
        keysGeneration: {
            configureStep: {
                create: "Sleutelceremonie Aanmaken",
                name: "Naam Sleutelceremonie",
                allElections: "Alle Verkiezingen",
                title: "Sleutelceremonie Verkiezingsevenement Aanmaken",
                subtitle: "Tijdens de sleutelceremonie genereert en downloadt elke trustee zijn fragment van de privésleutel voor het verkiezingsevenement. Kies de trustees die deelnemen aan de ceremonie en de drempelwaarde (het minimum aantal trustees nodig voor de telling) om door te gaan.",
                threshold: "Drempelwaarde",
                trusteeList: "Trustees",
                errorMinTrustees_one: "U selecteerde slechts {{selected}} trustee, maar u moet er minstens {{threshold}} selecteren.",
                errorMinTrustees_many: "U selecteerde slechts {{selected}} trustees, maar u moet er minstens {{threshold}} selecteren.",
                errorMinTrustees_other: "U selecteerde slechts {{selected}} trustees, maar u moet er minstens {{threshold}} selecteren.",
                errorThreshold: "U selecteerde drempelwaarde {{selected}}, maar deze moet tussen {{min}} en {{max}} liggen.",
                errorCreatingCeremony: "Fout bij aanmaken sleutelceremonie: {{error}}",
                createCeremonySuccess: "Sleutelceremonie aangemaakt",
                confirmdDialog: {
                    ok: "Ja, Sleutelceremonie Aanmaken",
                    cancel: "Annuleren",
                    title: "Weet u zeker dat u de Sleutelceremonie wilt aanmaken?",
                    automaticCeremonyTitle: "Weet u zeker dat u een automatische sleutelceremonie wilt creëren?",
                    description: "U staat op het punt een Sleutelceremonie aan te maken. Deze actie zal de Trustees informeren om deel te nemen aan de aanmaak en distributie van de Sleutels van het Verkiezingsevenement.",
                    automaticCeremonyDescription: "U staat op het punt een automatische sleutelceremonie te creëren. Dit zal de beheerders niet op de hoogte stellen om deel te nemen.",
                },
                filterTrustees: "Trustees filteren",
                errorPermisionLabels: "Sleutelceremonie kan niet worden aangemaakt: een of meer toestemmingslabels ontbreken.",
                automaticCeremonyToggle: "Automatische ceremonie",
            },
            ceremonyStep: {
                cancel: "Sleutelceremonie Annuleren",
                progressHeader: "Voortgang Sleutelceremonie",
                description: "Dit scherm toont de voortgang en logs van de Sleutelceremonie van het Verkiezingsevenement. Tijdens de Sleutelceremonie genereert en downloadt elke trustee zijn fragment van de privésleutel voor het Verkiezingsevenement.",
                executionStatus: "Status: {{status}}",
                confirmdDialog: {
                    ok: "Ja, Sleutelceremonie Annuleren",
                    cancel: "Terug naar Sleutelceremonie",
                    title: "Weet u zeker dat u de Sleutelceremonie wilt annuleren?",
                    description: "U staat op het punt de Sleutelceremonie te annuleren. Na deze actie moet u een nieuwe aanmaken voor een succesvolle Sleutelceremonie.",
                },
                header: {
                    trusteeName: "Naam Trustee",
                    fragment: "Sleutelfragment Gegenereerd",
                    downloaded: "Privésleutelfragment Gedownload",
                    checked: "Privésleutelfragment Gecontroleerd",
                },
                logsHeader: {
                    title: "Logs",
                    date: "Datum",
                    entry: "Logbericht",
                },
                emptyLogs: "Nog geen logs.",
            },
            startStep: {
                title: "Sleutelceremonie Trustee",
                subtitle: "U staat op het punt deel te nemen aan de Sleutelceremonie als Trustee (<strong>{{name}}</strong>). Dit omvat de volgende stappen:",
                one: "<strong>Download</strong> uw Versleutelde Privésleutel.",
                two: "Maak meerdere <strong>Back-ups</strong> van de Versleutelde Privésleutel.",
                three: "<strong>Controleer</strong> of de back-ups goed werken.",
            },
            downloadStep: {
                title: "Versleutelde Privésleutel Downloaden",
                subtitle: "Om door te gaan, download en bewaar uw Versleutelde Privésleutel op minstens twee verschillende apparaten:",
                downloadButton: "Download uw Versleutelde Privésleutel",
                downloaded: "Versleutelde privésleutel succesvol gedownload.",
                errorEmptyKey: "Downloadfout, leeg bestand",
                unexpectedError: "De privésleutel kon niet worden gedownload. Probeer het opnieuw.",
                alreadyVerified: "Uw privésleutel was al gedownload en geverifieerd.",
                unavailable: "De privésleutel kan niet meer worden gedownload omdat de ceremonie is gevorderd.",
                confirmdDialog: {
                    ok: "Back-ups Bevestigen en Doorgaan",
                    cancel: "Terug",
                    title: "Maak een back-up van uw Versleutelde Privésleutel",
                    description: "Maak een back-up van uw Versleutelde Privésleutel op minstens twee verschillende veilige locaties en bevestig dit hieronder:",
                    firstCopy: "Eerste back-up beveiligd",
                    secondCopy: "Tweede back-up beveiligd",
                    confirmError: "Maak de vereiste back-ups en vink de bevestigingsvakjes aan om door te gaan",
                },
            },
            checkStep: {
                title: "Controleer uw Back-ups van de Versleutelde Privésleutel",
                verifyButton: "Sleutel verifiëren",
                subtitle: "Upload een Back-up van de Versleutelde Privésleutel om te controleren of deze correct is. U kunt het zo vaak als nodig proberen, vanaf uw verschillende back-ups:",
                errorUploading: "Ongeldige Back-up van Versleutelde Privésleutel, probeer opnieuw",
                errorEmptyFile: "Bestand leeg of niet gevonden",
                verified: "Back-up succesvol geverifieerd.",
                alreadyRestored: "Uw sleutel was al hersteld.",
            },
        },
        miruExport: {
            create: {
                success: "Transmissiepakket aanmaken...",
                error: "Fout bij aanmaken Transmissiepakket ",
            },
            send: {
                success: "Transmissiepakket verzenden...",
                error: "Fout bij verzenden Transmissiepakket ",
            },
        },
        tally: {
            numericResultsReportsPending: "De numerieke resultaten zijn compleet. De rapporten worden nog gegenereerd.",
            errorUploadingSignature: "Er was een fout bij het uploaden van de handtekening",
            downloadTransmissionPackage: "Transmissiepakket Downloaden",
            resultsPublication: {
                sectionTitle: "Publiceren op de resultatenwebsite",
                policyTitle: "Resultatenwebsite",
                policyAccess: "Toegang tot resultatenwebsite",
                policyVisibility: "Zichtbaarheid van resultatenwebsite",
                enabled: "Ingeschakeld",
                disabled: "Uitgeschakeld",
                fullEvent: "Volledig evenement",
                areaBased: "Per gebied",
                publishStarted: "Publicatie van resultaten gestart",
                publishError: "Kon de publicatie van resultaten niet starten",
                revoked: "Publicatie van resultaten ingetrokken",
                revokeError: "Kon de publicatie van resultaten niet intrekken",
                waitingForTally: "Resultaten kunnen worden gepubliceerd nadat deze telling is voltooid.",
                writePermissionRequired: "U hebt de permissie publish-results-write nodig om resultaten te publiceren of in te trekken.",
                readPermissionRequired: "U hebt de permissie publish-results-read nodig om de publicatiegeschiedenis te bekijken.",
                disabledPolicy: "Publiceren op de resultatenwebsite is uitgeschakeld voor dit verkiezingsevenement. Schakel het in bij de gegevens van het verkiezingsevenement voordat u resultaten publiceert.",
                loadingElectionContext: "De resultatenpublicatie laadt de verkiezingscontext.",
                route: "Route",
                eventResults: "Resultaten van het evenement",
                electionResults: "Verkiezingsuitslagen",
                election: "Verkiezing",
                access: "Toegang",
                publicAccess: "Openbare toegang",
                authenticatedAccess: "Geverifieerde toegang",
                visibility: "Zichtbaarheid",
                fullPublishedScope: "Volledige gepubliceerde reikwijdte",
                personalVisibility: "Persoonlijke zichtbaarheid",
                contests: "Stemmingen",
                noTalliedContests: "Geen getelde stemmingen beschikbaar.",
                publishSelectedContests: "Geselecteerde stemmingen publiceren",
                selectedContestCount_one: "{{count}} stemming geselecteerd",
                selectedContestCount_many: "{{count}} stemmingen geselecteerd",
                selectedContestCount_other: "{{count}} stemmingen geselecteerd",
                history: "Publicatiegeschiedenis",
                version: "Versie",
                status: "Status",
                published: "Gepubliceerd",
                revokedAt: "Ingetrokken",
                actions: "Acties",
                open: "Openen",
                revoke: "Intrekken",
                noPublications: "Nog geen publicaties.",
                confirmTitle: "Publiceren op de resultatenwebsite starten?",
                confirmDescription: "Hiermee wordt een nieuwe publicatie gemaakt op basis van de huidige telling. De bestaande resultaten voor kiezers blijven actief totdat deze publicatietaak is geslaagd.",
                close: "Sluiten",
            },
            transmissionPackage: {
                title: "Transmissiepakket voor Gebied '{{name}}' en Verkiezing '{{eventName}}'",
                description: "Hiermee kunt u een Transmissiepakket exporteren naar Bestemmingsservers of downloaden.",
                actions: {
                    send: {
                        title: "Verzenden",
                        dialog: {
                            title: "Wilt u het Transmissiepakket Verzenden?",
                            description: "Bevestig dat u het Transmissiepakket voor Gebied `{{name}}` wilt verzenden naar de Bestemmingsservers.",
                            confirm: "Transmissiepakket Verzenden",
                            cancel: "Sluiten",
                        },
                    },
                    regenerate: {
                        title: "Regenereren",
                        dialog: {
                            title: "Wilt u het Transmissiepakket regenereren?",
                            description: "Bevestig dat u het Transmissiepakket voor Gebied `{{name}}` wilt regenereren",
                            confirm: "Transmissiepakket Regenereren",
                            cancel: "Sluiten",
                        },
                    },
                    sign: {
                        title: "Ondertekenen",
                        dialog: {
                            title: "Wilt u het Transmissiepakket ondertekenen?",
                            description: "Bevestig dat u het Transmissiepakket voor Gebied `{{name}}` wilt ondertekenen",
                            confirm: "Transmissiepakket Ondertekenen",
                            cancel: "Sluiten",
                            input: {
                                placeholder: "Voer uw wachtwoord in",
                            },
                        },
                    },
                    download: {
                        title: "Downloaden",
                        emlTitle: "EML Downloaden {{date}}",
                        transmissionPackageTitle: "Transmissiepakket Downloaden {{date}}",
                        transmissionReportTitle: "Transmissierapport Downloaden",
                        dialog: {
                            title: "Wilt u het Transmissiepakket Downloaden?",
                            description: "Bevestig dat u het Transmissiepakket voor Gebied `{{name}}` wilt downloaden.",
                            confirm: "Transmissiepakket Downloaden",
                            cancel: "Sluiten",
                        },
                    },
                },
                destinationServers: {
                    title: "Bestemmingsservers",
                    description: "De onderstaande tabel toont de verzendstatus van elk van de Bestemmingsservers.",
                    status: "Verzonden naar {{signed}} van {{total}}",
                    table: {
                        serverName: "Servernaam",
                        sendStatus: "Verzendstatus",
                    },
                },
                signatures: {
                    title: "SBEI Handtekeningen",
                    description: "SBEI's kunnen het Transmissiepakket ondertekenen. De onderstaande tabel toont de ondertekeningsstatus van elk van de SBEI-leden.",
                    status: "{{signed}} van {{total}} Ondertekend, {{minimum}} minimum",
                    table: {
                        trusteeName: "SBEI-id",
                        signed: "Heeft Ondertekend",
                    },
                },
            },
            sendToTransmissionPackageServers: "Verzend Transmissiepakket voor Gebied '{{name}}'",
            uploadTransmissionPackage: "Transmissiepakket Ondertekenen",
            uploadTransmissionPackageDesc: "Upload uw Handtekening om het Transmissiepakket te ondertekenen. Dit is een optionele handeling.",
            exportElectionArea: "Genereer Transmissiepakket voor Gebied '{{name}}'",
            generateReport: "Genereer {{name}}",
            templateTitle: "Resultatensjabloon",
            templateSubTitle: "Overschrijf optioneel het resultatensjabloon.",
            keysCeremonyTitle: "Sleutelceremonie",
            keysCeremonySubTitle: "Selecteer de Sleutelceremonie voor deze telling",
            ceremonyTitle: "Te Tellen Verkiezingen",
            initializationTitle: "Verkiezingen voor Initialisatierapport",
            ceremonySubTitle: "Kies de verkiezingen die u wilt tellen",
            tallyTitle: "Voortgang Telling Verkiezingen",
            logsTitle: "Logs",
            resultsTitle: "Resultaten & Deelname",
            generalInfoTitle: "Algemene Informatie",
            trusteeTallyTitle: "Trustees",
            trusteeTallySubTitle: "Status import sleutelfragment",
            eligibility: {
                selectElection: "Selecteer ten minste één verkiezing.",
                publishElection: "Publiceer elke geselecteerde verkiezing voordat u de telling aanmaakt.",
                tallyDisallowed: "Tellen is uitgeschakeld voor een geselecteerde verkiezing.",
                endVoting: "Beëindig het stemmen in elke geselecteerde verkiezing en stop de actieve stemkanalen voordat u de telling aanmaakt.",
            },
            createTallySuccess: "Telling aangemaakt",
            createTallyError: "Kon telling niet aanmaken",
            startTallySuccess: "Telling gestart",
            startTallyError: "Kon telling niet starten",
            startTallyCeremonySuccess: "Telceremonie gestart",
            startTallyCeremonyError: "Kon telceremonie niet starten",
            cancelTallyCeremonySuccess: "Telceremonie geannuleerd",
            cancelTallyCeremonyError: "Kon telceremonie niet annuleren",
            recountTallyCeremony: "Hertelling",
            recountTallyCeremonyMessage: "Dit genereert een nieuw resultatenevenement voor de voltooide telsessie.",
            recountTallyCeremonyStarting: "Hertelling wordt gestart...",
            recountTallyCeremonySuccess: "Hertelling gestart",
            recountTallyCeremonyError: "Kon hertelling niet starten",
            recountTallyCeremonyOk: "Hertellen",
            trusteeTitle: "Proces Trustees",
            trusteeSubTitle: "Gelieve uw sleutelfragment te uploaden",
            invited: "U bent uitgenodigd om deel te nemen aan een Telceremonie. Gelieve ",
            click: "op de Telactie te klikken",
            participate: "om deel te nemen.",
            breadcrumbSteps: {
                start: "Starten",
                finish: "Voltooien",
                tally: "Tellen",
                results: "Resultaten",
                ceremony: "Ceremonie",
            },
            common: {
                title: "Telling",
                subTitle: "Configuratie telling.",
                cancel: "Terug",
                next: "Volgende",
                date: "Datum Telling",
                global: "Globaal",
                noTrustees: "Nog geen trustees",
                imported: " trustees hebben de sleutel geïmporteerd",
                needed: " trustees nodig",
                start: "Start Telling",
                ceremony: "Start Telceremonie",
                initialization: "Start Initialisatierapport",
                results: "Resultaten",
                dialog: {
                    ok: "Ok",
                    okTally: "Start Telling",
                    okCancel: "Annuleer Telling",
                    cancel: "Sluiten",
                    title: "Weet u zeker dat u een ceremonie wilt starten?",
                    tallyTitle: "Weet u zeker dat u de telling wilt starten?",
                    cancelTitle: "Weet u zeker dat u de telling wilt annuleren?",
                    message: "U staat op het punt een telceremonie te starten. Deze actie zal de trustees informeren om hun sleutelfragmenten te importeren.",
                    cancelMessage: "U staat op het punt de telceremonie te annuleren. Deze actie kan niet ongedaan worden gemaakt.",
                    ceremony: "Alle vereiste trustees hebben hun sleutelfragmenten geverifieerd. Alles is klaar om resultaten te ontvangen. Wilt u de Telling starten?",
                    startAutomatedTallyMessage: "Selecteer 'Start Tally' om het telproces uit te voeren en de resultaten weer te geven, of 'Close' om te annuleren.",
                },
            },
            table: {
                elections: "Verkiezingen",
                selected: "Geselecteerd",
                status: "Status",
                progress: "Voortgang",
                method: "Telmethode",
                elegible: "Stemgerechtigde Kiezers",
                number: "Aantal Stemmen",
                total: "Totaal",
                turnout: "%",
                candidates: "Resultaten Kandidaten",
                options: "Opties",
                global: "Overzicht Deelname",
                elegible_census: "Stemgerechtigde Kiezers",
                cast_votes: "Aantal Uitgebrachte Stemmen",
                cast_votes_percent: "Percentage Uitgebrachte Stemmen",
                total_votes: "Totaal Aantal Kiezers",
                total_votes_percent: "Deelnamepercentage",
                total_votes_counted: "Totaal Getelde Stemmen",
                total_auditable_votes: "Totaal Controleerbare Stemmen",
                total_valid_votes: "Totaal Geldige Stemmen",
                total_valid_votes_percent: "Percentage Geldige Stemmen",
                total_invalid_votes: "Totaal Ongeldige Stemmen",
                total_invalid_votes_percent: "Percentage Ongeldige Stemmen",
                explicit_invalid_votes: "Expliciet Ongeldige Stemmen",
                explicit_invalid_votes_percent: "Percentage Expliciet Ongeldige Stemmen",
                implicit_invalid_votes: "Impliciet Ongeldige Stemmen",
                implicit_invalid_votes_percent: "Percentage Impliciet Ongeldige Stemmen",
                blank_votes: "Blanco Stemmen",
                explicit_blank_votes: "Expliciete Blanco Stemmen",
                implicit_blank_votes: "Impliciete Blanco Stemmen",
                blank_votes_percent: "Percentage Blanco Stemmen",
                number_of_votes: "Aantal Stemmen",
                winning_position: "Winnende positie",
                weight: "Gewicht",
                preferential: {
                    candidate: "Kandidaat",
                    winner: "Winnaar",
                    eliminated: "Geëlimineerd",
                    round: "Ronde",
                },
                total_declined_to_vote: "Totaal aantal weigeringen om te stemmen",
                total_blank_ballots: "Totaal Aantal Blanco Stembiljetten",
                participation_by_channel: "Deelname per kanaal",
                channel: "Kanaal",
                channel_online: "Online",
                channel_kiosk: "Kiosk",
                channel_early_voting: "Vervroegd stemmen",
                channel_telephone: "Telefoon",
                channel_paper: "Papier",
                channel_postal: "Post",
                channel_in_person: "Persoonlijk",
                acclamation_note: "Bij acclamatie gekozen. Deze stemming is zonder stemming beslist, dus er zijn geen stemmen geregistreerd.",
            },
            pendingResolutions: {
                round: "Ronde {{round}}",
                tieResolutionRequired: "Stemgelijkheid vereist oplossing",
                tieResolved: "Stemgelijkheid opgelost",
                globalArea: "Globaal",
                pendingResolutionsHeader: "Openstaande resoluties",
                pendingResolutionStatus: "Resolutie in behandeling",
                resolvedStatus: "Opgelost",
                resolutionTitle: "Beslissing",
                selectContest: "Selecteer een item aan de linkerkant om de details te bekijken",
                selectCandidateToAdvance: "Selecteer kandidaat om door te laten gaan",
                undoResolution: "Beslissing ongedaan maken",
                applyResolutions: "Beslissingen toepassen en herberekenen",
                submitSuccess: "Beslissingen ingediend. De telling wordt hervat...",
                submitError: "Fout bij het indienen van beslissingen. Probeer het opnieuw.",
                filter: "Filteren",
                save: "Opslaan",
                pendingApplyStatus: "Berekening in afwachting",
                filterElection: "Verkiezing",
                filterContest: "Stemming",
                filterArea: "Gebied",
                filterStatusLabel: "Status",
                clearFilters: "Filters wissen",
                candidateWithVotes: "{{name}} ({{votes}} stemmen)",
                candidateWithVotesAndPercent: "{{name}} ({{votes}} stemmen, {{percent}}%)",
                tieInfoTitle: "Telling gepauzeerd wegens onopgelost gelijkspel (Ronde {{round}})",
                tieInfoBody: "Kandidaten gelijk ({{votes}} stemmen, {{percent}}%): {{candidates}}. Handmatige tiebreak vereist om de telling voort te zetten.",
                tallyResumedTitle: "Telling hervat na toepassing van de resolutie",
                tallyResumedBody: "De gelijkstand werd opgelost op {{date}} door {{user}}",
            },
            chart: {
                votesForCandidates: "Stemmen voor Kandidaten",
                blankVotes: "Blanco Stemmen",
                invalidVotes: "Ongeldige Stemmen",
                totalVoters: "Totaal Kiezers",
                nonVoters: "Niet-kiezers",
            },
            exportAllAreas: "Exporteer de resultaten van alle gebieden in {{format}}-formaat voor '{{item}}'",
        },
        publish: {
            preview: {
                publicationAreas: "Selecteer Gebied voor Voorbeeldweergave",
                action: "Voorbeeldweergave",
                copy: "Link kopiëren",
                copy_success: "Voorbeeldlink succesvol gekopieerd",
                copy_error: "Kopiëren voorbeeldlink mislukt",
                success: "Voorbeeldweergave succesvol geopend",
            },
            header: {
                change: "Te Publiceren Wijzigingen",
                viewChange: "Publicatie Bekijken",
                history: "Publicatiegeschiedenis",
            },
            action: {
                generateInitializationReport: "Initialisatierapport Genereren",
                startVotingPeriod: "Stemperiode Starten",
                startKioskVoting: "Kioskstemmen Starten",
                startOnlineVoting: "Online Stemmen Starten",
                startEarlyVoting: "Vroeg Stemmen Starten",
                startTelephoneVoting: "Telefonisch Stemmen Starten",
                stopVotingPeriod: "Stemperiode Stoppen",
                stopOnlineVoting: "Online Stemmen Stoppen",
                stopEarlyVoting: "Vroeg Stemmen Stoppen",
                stopTelephoneVoting: "Telefonisch Stemmen Stoppen",
                stopKioskVotingPeriod: "Kiosk Stemmen Stoppen",
                pauseVotingPeriod: "Stemperiode Pauzeren",
                pauseKioskVoting: "Kioskstemmen Pauzeren",
                pauseOnlineVoting: "Online Stemmen Pauzeren",
                pauseEarlyVoting: "Vroeg Stemmen Pauzeren",
                pauseTelephoneVoting: "Telefonisch Stemmen Pauzeren",
                generate: "Regenereren",
                publish: "Wijzigingen Publiceren",
                back: "Terug",
            },
            label: {
                current: "Huidige",
                previous: "Vorige Publicatie",
                publication: "Publicatie",
                diff: "Te Publiceren Wijzigingen",
            },
            empty: {
                header: "Nog geen publicatie.",
                action: "Publicatie Genereren",
            },
            forbidden: {
                header: "Publiceren niet mogelijk totdat de Sleutelceremonie is voltooid.",
            },
            dialog: {
                title: "Actie Bevestigen",
                info: "U hebt op een gevoelige actie geklikt, bevestig alstublieft om door te gaan",
                initializationInfo: "U staat op het punt een initialisatierapport te genereren. Weet u zeker dat u wilt doorgaan?",
                startInfo: "U staat op het punt de stemperiode te starten. Weet u zeker dat u wilt doorgaan?",
                stopInfo: "U staat op het punt de stemperiode te stoppen. Weet u zeker dat u wilt doorgaan?",
                kioskStopInfo: "U staat op het punt de kiosk stemperiode te stoppen. Weet u zeker dat u wilt doorgaan?",
                pauseInfo: "U staat op het punt de stemperiode te pauzeren. Weet u zeker dat u wilt doorgaan?",
                publishInfo: "U staat op het punt een publicatie te genereren. Weet u zeker dat u wilt doorgaan?",
                ok: "Bevestigen",
                ko: "Annuleren",
                error: "Fout bij laden publicatie stembiljet",
                error_publish: "Fout bij publiceren publicatie stembiljet",
                error_capacity: "Genereren van stembiljetstijl mislukt: {{message}}",
                error_status: "Fout bij wijzigen status publicatie stembiljet",
                error_preview: "Fout bij voorbeeldweergave publicatie",
                diff: "Het weergeven van alle wijzigingen kan de pagina traag maken. Weet u zeker dat u wilt doorgaan?",
                confirmation: "De actie die u gaat uitvoeren is gevoelig en vereist bevestiging. Voer uw wachtwoord in om door te gaan met {{action}}.",
            },
            notifications: {
                generated: "Stembiljet gegenereerd",
                published: "Stembiljet gepubliceerd",
                change_status: "Verkiezingsstatus gewijzigd",
            },
        },
        emailEditor: {
            subject: "Onderwerp e-mail",
            tabs: {
                plaintext: "Platte Tekst Body",
                richtext: "Opgemaakte tekst",
            },
        },
        sendCommunication: {
            send: "Verzenden",
            title: "Melding Verzenden",
            subtitle: "Een melding verzenden naar kiezers.",
            sendButton: "Melding Verzenden",
            voters: "Doelgroep",
            schedule: "Planning",
            nowInput: "Nu verzenden",
            dateInput: "Datum en tijd om meldingen te verzenden",
            chooseDate: "Kies een datum",
            languages: "Talen",
            smsMessage: "SMS-bericht",
            errorSending: "Fout bij verzenden melding: {{error}}",
            successSending: "Melding succesvol ingepland/verzonden",
            method: "Methode Sjabloon",
            type: "Communicatietype",
            alias: "Alias Sjabloon",
            votersSelection: {
                ALL_USERS: "Iedereen",
                NOT_VOTED: "Degenen die nog niet gestemd hebben",
                VOTED: "Degenen die al gestemd hebben",
                SELECTED: "Naar {{total}} Geselecteerde {{voters}}",
            },
            path: {
                users: "gebruikers",
                voters: "kiezers",
            },
            methodTitle: "Communicatiesjabloon",
            communicationMethod: {
                EMAIL: "E-mail",
                SMS: "SMS",
            },
            communicationType: {
                CREDENTIALS: "Inloggegevens",
                BALLOT_RECEIPT: "Ontvangstbewijs Stembiljet",
            },
            email: {
                subject: "Onderwerp",
            },
        },
        tallysheet: {
            title: "Stembussen",
            subtitle: "Digitaal gestemde stembussen per kanaal",
            createTallySuccess: "Telblad opgeslagen",
            createTallyError: "Fout bij opslaan telblad",
            createTallyErrorSameKindExists: "Telformulier bestaat al voor deze stemming met hetzelfde kanaal en gebied",
            allFieldsRequired: "Alle velden zijn verplicht",
            header: {
                change: "Te Publiceren Wijzigingen",
                viewChange: "Publicatie Bekijken",
                history: "Publicatiegeschiedenis",
            },
            action: {
                start: "Start Verkiezing",
                stop: "Stop Verkiezing",
                pause: "Pauzeren",
                generate: "Regenereren",
                publish: "Wijzigingen Publiceren",
                back: "Terug",
            },
            inputError: {
                totalValidDoesNotMatch: "Kandidaatstemmen ({{candidateVotesSum}}) moeten tussen {{lowerBound}} en {{upperBound}} liggen volgens de stemregels van deze stemming ({{nonBlankValidVotes}} geldige niet-blanco stemmen × maximaal {{maxMarks}} markeringen per stembiljet)",
                censusTooSmall: "Het totaal aantal stemmen ({{totalVotes}}) mag niet groter zijn dan de census ({{census}})",
                totalInvalidDoesNotMatch: "Het totaal aantal ongeldige stemmen ({{totalInvalid}}) moet gelijk zijn aan impliciet ongeldige stemmen ({{implicitInvalid}}) plus expliciet ongeldige stemmen ({{explicitInvalid}})",
                totalVotesDoesNotMatch: "Het totaal aantal stemmen ({{totalVotes}}) moet gelijk zijn aan het totaal aantal geldige stemmen ({{totalValidVotes}}) plus het totaal aantal ongeldige stemmen ({{totalInvalid}})",
                unknownCountingAlgorithm: "Het telalgoritme van deze stemming ({{countingAlgorithm}}) wordt niet herkend, waardoor het toegestane aantal kandidaatstemmen niet kan worden bepaald. Controleer de configuratie van de stemming.",
                blankBallotsInconsistent: "Blanco Stembiljetten moeten dezelfde waarde hebben op elk telformulier van deze stembus",
                blankBallotsOutOfBounds: "De waarde van Blanco Stembiljetten valt buiten het bereik dat wordt geïmpliceerd door de blanco-stemtellingen per stemming van deze stembus",
            },
            label: {
                area: "Gebied",
                channel: "Kanaal",
                total_votes: "Totaal Stemmen",
                total_valid_votes: "Totaal Geldige Stemmen",
                total_invalid: "Totaal Ongeldige Stemmen",
                explicit_invalid: "Expliciet Ongeldige Stemmen",
                implicit_invalid: "Impliciet Ongeldige Stemmen",
                total_blank_votes: "Blanco Stemmen",
                blank_ballots: "Blanco Stembiljetten",
                census: "Kieserslijst",
            },
            common: {
                tallyCeremony: {
                    manage: "Telceremonie Beheren",
                    view: "Telceremonie Bekijken",
                    cancel: "Telceremonie Annuleren",
                    addKey: "Telsleutel Toevoegen",
                },
                edit: "Bewerken",
                confirm: "Bevestigen",
                back: "Terug",
                next: "Volgende",
                cancel: "Terug",
                data: "Gegevens",
                title: "Telblad",
                subtitle: "Configuratie telblad.",
                candidates: "Kandidaten",
                save: "Opslaan",
                approve: "Goedkeuren",
                disapprove: "Afkeuren",
                show: "Tonen",
                add: "Toevoegen",
                versions: "Versies",
                warningDisapprove: "Weet u zeker dat u dit Telformulier wilt afkeuren?",
                warningApprove: "Weet u zeker dat u dit Telformulier wilt goedkeuren?",
            },
            empty: {
                header: "Nog geen telblad.",
                action: "Telblad Genereren",
                add: "Toevoegen",
            },
            breadcrumbSteps: {
                start: "Starten",
                edit: "Bewerken",
                confirm: "Bevestigen",
                view: "Bekijken",
            },
            table: {
                area: "Gebied",
                contest: "Stemming",
                approvedVersion: "Goedgekeurde versie",
                latestVersion: "Nieuwste versie",
                labels: "Labels",
                annotations: "Annotaties",
            },
            versionsTable: {
                title: "Versies van de stembus",
                version: "Versie",
                createdBy: "Gemaakt door",
                reviewedBy: "Beoordeeld door",
                createdAt: "Gemaakt op",
                reviewedAt: "Beoordeeld op",
                sourceImport: "Bronimport",
                importStatus: "Importstatus",
                openImport: "Import openen",
                sourceFile: "Bronbestand",
            },
            message: {
                reviewError: "Fout bij beoordelen telblad",
                reviewSuccess: "Telblad beoordeeld",
            },
        },
        application: {
            import: {
                title: "Applicaties Importeren",
                subtitle: "Gegevens applicaties importeren",
                paragraph: "Importeer applicaties met een spreadsheetbestand in CSV-formaat (Comma Separated Values). Download hier een voorbeeld CSV-importbestand.",
                messages: {
                    success: "Applicaties succesvol geïmporteerd",
                    error: "Fout bij importeren applicaties",
                },
            },
            export: {
                title: "Applicaties Exporteren",
                subtitle: "Gegevens applicaties exporteren",
                button: "Exporteren",
                paragraph: "Exporteer applicatiegegevens naar een spreadsheetbestand in CSV-formaat (Comma Separated Values).",
                messages: {
                    success: "Applicaties succesvol geëxporteerd",
                    error: "Fout bij exporteren applicaties",
                },
            },
        },
        template: {
            noPermissions: "U hebt geen toestemming om toegang te krijgen tot sjablonen.",
            title: "Sjablonen",
            subtitle: "Lijst van sjablonen",
            chooseMethods: "Kies Methoden",
            default: "Standaardsjabloon gebruiken",
            empty: {
                title: "Nog geen sjabloon",
                subtitle: "Wilt u er een aanmaken?",
            },
            action: {
                createOne: "Sjabloon Aanmaken",
            },
            create: {
                title: "Een Sjabloon Aanmaken",
                success: "Sjabloon aangemaakt",
                error: "Fout bij aanmaken sjabloon",
            },
            update: {
                success: "Sjabloon bijgewerkt",
                error: "Fout bij bijwerken sjabloon",
            },
            edit: {
                title: "Een Sjabloon Bewerken",
            },
            form: {
                smsMessage: "SMS-bericht",
                document: "Document",
                pdfOptions: "PDF Opties",
                reportOptions: "Rapport Opties",
                name: "Naam Sjabloon",
                alias: "Alias Sjabloon",
                type: "Type",
                communicationMethod: "Methode",
            },
            type: {
                CREDENTIALS: "Inloggegevens",
                INITIALIZATION_REPORT: "Initialisatierapport",
                ELECTORAL_RESULTS: "Verkiezingsresultaten",
                BALLOT_IMAGES: "Afbeeldingen Stembiljetten",
                BALLOT_RECEIPT: "Ontvangstbewijs Stembiljet",
                ACTIVITY_LOGS: "Activiteitenlogs",
                MANUAL_VERIFICATION: "Handmatige Verificatie",
                PARTICIPATION_REPORT: "Participatierapport",
            },
            method: {
                email: "E-mail",
                sms: "SMS",
                document: "Document",
            },
            import: {
                title: "Sjablonen Importeren",
                subtitle: "Gegevens sjablonen importeren",
                paragraph: "Importeer sjablonen met een spreadsheetbestand in CSV-formaat (Comma Separated Values). Download hier een voorbeeld CSV-importbestand.",
            },
        },
        materials: {
            createMaterialSuccess: "Ondersteunend materiaal aangemaakt",
            createMaterialError: "Fout bij aanmaken ondersteunend materiaal",
            updateMaterialSuccess: "Ondersteunend materiaal bijgewerkt",
            updateMaterialError: "Fout bij bijwerken ondersteunend materiaal",
            common: {
                title: "Ondersteunend Materiaal",
                subtitle: "Voer gegevens voor ondersteunend materiaal in.",
            },
            error: {
                title: "Titel is verplicht",
                document: "Document is verplicht",
            },
            fields: {
                isHidden: "Is Verborgen",
                publicUrl: "Publieke URL",
            },
            empty: {
                header: "Nog geen ondersteunend materiaal",
                action: "Ondersteunend materiaal genereren",
            },
        },
        widget: {
            logs: "Logs",
        },
        settings: {
            countries: {
                title: "Landenblokkering",
                votingDescription: "Kies hieronder de landen waaruit u stemmen wilt blokkeren.",
                enrollmentDescription: "Kies hieronder de landen waaruit u inschrijvingen wilt blokkeren.",
                error: {
                    errorSaving: "Fout bij opslaan landenlijst",
                },
            },
            backupRestore: {
                title: "Back-up / Herstellen Tenantconfiguratie",
                backup: {
                    label: "Back-up",
                    subtitle: "Back-up maken van Tenantconfiguraties",
                },
                restore: {
                    label: "Herstellen",
                    subtitle: "Tenantconfiguratie herstellen",
                    title: "Tenantconfiguraties Importeren",
                    paragraph: "Importeer tenantconfiguraties, Keycloak-configuraties, rollen & machtigingengegevens met een zip-map",
                    tenantConfigOption: "Tenantconfiguraties Importeren",
                    keycloakConfigOption: "Keycloak-configuraties Importeren",
                    RolesConfigOption: "Configuraties Rollen & Machtigingen Importeren",
                },
            },
            previewScreen: {
                label: "Voorbeeldweergaven",
                noContent: "Geen voorbeeldweergaven gevonden",
                table: {
                    title: "Externe voorvertoningen",
                    description: "Een overzicht van voorvertoningen van stembiljetstijlen die zijn gegenereerd via externe verzoeken",
                    requestedBy: "Aangevraagd door",
                    document: "Document",
                    url: "URL",
                },
            },
            languages: {
                default: "Standaardtaal",
            },
        },
        approvalsScreen: {
            column: {
                status: "Status",
                id: "ID",
                applicantId: "ID Aanvrager",
                verificationType: "Verificatietype",
                createdAt: "Aangemaakt op",
                updatedAt: "Bijgewerkt op",
                verified_by: "Geverifieerd door",
            },
            approvalRequest: "Goedkeuringsverzoek",
            title: "Kiezers",
            subtitle: "Overeenkomende kiezers zoeken",
            approve: {
                body: "Weet u zeker dat u deze kiezer wilt goedkeuren? Deze actie kan niet ongedaan worden gemaakt.",
            },
            reject: {
                label: "Aanvraag Afkeuren",
                confirm: "Weet u zeker dat u deze kiezer wilt afkeuren? Deze actie kan niet ongedaan worden gemaakt.",
                rejectReason: "Reden van Afkeuring",
                message: "Schrijf hier de reden van afkeuring",
                messageRequired: "Een afkeuringsbericht is vereist voor de optie 'Andere'.",
                reasons: {
                    "undefined": "-",
                    "insufficient-information": "Ontbrekende Gegevens",
                    "no-matching-voter": "Geen Overeenkomende Kiezer",
                    "voter-already-approved": "Reeds Goedgekeurd",
                    "other": "Andere",
                },
            },
            notifications: {
                approveError: "Fout bij goedkeuren kiezer",
                approveSuccess: "Kiezer goedgekeurd",
                rejectError: "Fout bij afkeuren kiezer",
                rejectSuccess: "Kiezer afgekeurd",
                VoterApprovedAlready: "Kiezer is reeds goedgekeurd.",
            },
            export: {
                success: "Export applicaties succesvol voltooid",
                error: "Fout bij exporteren applicaties",
            },
        },
        monitoringDashboardScreen: {
            voters: {
                title: "Kiezers",
                enrolledOverseasVoters: "Ingeschreven Buitenlandse Kiezers",
                approvalStatus: "Goedkeuringsstatus: Goedgekeurde/Afgekeurde Kiezers",
                manuallyApproval: "Handmatig Goedgekeurde/Afgekeurde Kiezers",
                automaticallyApproval: "Automatisch Goedgekeurde/Afgekeurde Kiezers",
                authenticatedVoters: "Geauthenticeerde Kiezers",
                invalidUserErrors: "Fouten Ongeldige Gebruiker:",
                invalidPasswordErrors: "Fouten Ongeldig Wachtwoord:",
            },
            polls: {
                title: "Stembureaus",
                initializedSystems: "Posten met Geïnitialiseerde Systemen",
                votingOpened: "Posten met Online Stemmen Geopend",
                votingClosed: "Posten met Beide Stemkanalen Gesloten",
                votingStarted: "Posten met Stemmen Gestart",
                voterTurnout: "Opkomst Kiezers",
            },
            tally: {
                title: "Telling",
                activeVotesCounting: "Posten met Actieve Stemtelling",
                generatedERs: "Posten met Gegenereerde Verkiezingsresultaten",
                transmittedResults: "Posten met Verzonden Resultaten",
            },
            testing: {
                title: "Testen",
                testElectionVoterCount: "Aantal Kiezers Testverkiezing",
            },
        },
        certificateAuthorities: {
            title: "Certificaten",
            subtitle: "Vertrouwde certificeringsinstanties (CA's) voor dit verkiezingsevenement. Geïmporteerde CA's worden gebruikt om kiezercertificaten te valideren.",
            importButton: "Certificaten importeren",
            type: {
                root: "Wortel",
                intermediate: "Tussenliggend",
            },
            expiry: {
                expired: "Verlopen",
                expiringSoon: "Verloopt binnenkort",
                valid: "Geldig",
            },
            columns: {
                commonName: "Gewone naam",
                type: "Type",
                issuerCn: "CN van uitgever",
                notBefore: "Geldig vanaf",
                notAfter: "Verloopt",
                fingerprint: "SHA256 Vingerafdruk",
            },
            importDialog: {
                title: "Certificaatautoriteiten importeren",
                subtitle: "Importeer een of meer CA-certificaten vanuit een PEM-bestand",
                description: "Selecteer een PEM-bestand met een of meer certificaten. Bundels worden ondersteund — elk certificaat wordt afzonderlijk geïmporteerd.",
                selectFile: "PEM-bestand selecteren",
                fileLoaded: "Bestand geladen ({{bytes}} bytes)",
                importButton: "Importeren",
            },
            notify: {
                importSuccess: "{{inserted}} certificaat(-en) geïmporteerd.",
                importSkipped: "{{count}} overgeslagen (al aanwezig).",
                importErrors: "Importproblemen: {{errors}}",
                importError: "Importeren mislukt: {{error}}",
                deleteSuccess: "Certificaat verwijderd.",
                deleteError: "Fout bij verwijderen van certificaat.",
                exportSuccess: "Certificaat(-en) succesvol geëxporteerd.",
                exportError: "Fout bij exporteren van certificaten.",
            },
            exportDialog: {
                title: "Certificaatautoriteiten exporteren",
                description: "U staat op het punt {{amount}} certificaat(-en) te exporteren.",
                all: "alle",
            },
            deleteDialog: {
                description: "Weet u zeker dat u {{count}} certificaat(-en) wilt verwijderen?",
            },
            emptyHeader: "Er zijn geen certificaatautoriteiten geïmporteerd voor dit verkiezingsevenement.",
            fileReadError: "Bestand lezen mislukt.",
            viewDialog: {
                title: "Details van certificaatautoriteit",
                subject: "Onderwerp",
                issuer: "Uitgever",
                serialNumber: "Serienummer",
                pemContent: "PEM-inhoud",
            },
            confirmDelete: "Certificaatautoriteit verwijderen",
            confirmDeleteDescription: 'Weet u zeker dat u het certificaat "{{name}}" (vingerafdruk: {{fingerprint}}) wilt verwijderen?',
        },
    },
};
export default dutchTranslation;
